import { r as e } from "./orynook-rolldown-runtime-Boh4KbhZ.js";
import { _ as t, a as n, b as r, c as i, d as a, f as o, g as s, h as c, i as l, l as u, m as d, n as f, o as p, p as m, r as h, s as g, t as _, u as v, v as y, y as b } from "./orynook-react-JbJYUkUD.js";
import { A as x, C as S, D as C, E as w, M as T, O as ee, S as E, T as te, _ as ne, a as re, b as D, c as O, d as k, f as A, g as ie, h as j, i as M, j as N, k as ae, l as P, m as F, n as I, o as L, p as R, r as z, s as oe, t as B, u as V, v as H, w as U, x as W, y as se } from "./orynook-vendor-8zByigwA.js";
//#region shopify-build/components/feature-icon.tsx
var G = /* @__PURE__ */ e(r(), 1), K = b(), q = y();
function J({ kind: e }) {
	return /* @__PURE__ */ (0, q.jsxs)("svg", {
		className: "orynook-feature-icon",
		viewBox: "0 0 40 40",
		fill: "none",
		"aria-hidden": "true",
		stroke: "currentColor",
		strokeWidth: "1.6",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ (0, q.jsx)("rect", {
				x: "2",
				y: "2",
				width: "36",
				height: "36",
				rx: "12",
				fill: "currentColor",
				fillOpacity: ".055",
				stroke: "none"
			}),
			e === "audio" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				/* @__PURE__ */ (0, q.jsx)("path", { d: "M13 28h14M16 24h8M17 11h6a2 2 0 0 1 2 2v8H15v-8a2 2 0 0 1 2-2Z" }),
				/* @__PURE__ */ (0, q.jsx)("path", {
					d: "M10 16a8 8 0 0 0 0 8M30 16a8 8 0 0 1 0 8",
					opacity: ".55"
				}),
				/* @__PURE__ */ (0, q.jsx)("path", {
					d: "M7 13a13 13 0 0 0 0 14M33 13a13 13 0 0 1 0 14",
					opacity: ".25"
				})
			] }),
			e === "bluetooth" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				/* @__PURE__ */ (0, q.jsx)("path", { d: "m15 14 12 12-7 5V9l7 5-12 12" }),
				/* @__PURE__ */ (0, q.jsx)("path", {
					d: "M11 17a8 8 0 0 0 0 6M31 17a8 8 0 0 1 0 6",
					opacity: ".4"
				}),
				/* @__PURE__ */ (0, q.jsx)("circle", {
					cx: "10",
					cy: "11",
					r: "1.5",
					fill: "currentColor",
					stroke: "none",
					opacity: ".45"
				})
			] }),
			e === "stand" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				/* @__PURE__ */ (0, q.jsx)("path", { d: "m15 11 12 3-4 15-12-3 4-15Z" }),
				/* @__PURE__ */ (0, q.jsx)("path", { d: "m23 24 6 7H12M18 30v-3" }),
				/* @__PURE__ */ (0, q.jsx)("path", {
					d: "M29 10a8 8 0 0 1 4 9m-3-2 3 2 2-3",
					opacity: ".5"
				}),
				/* @__PURE__ */ (0, q.jsx)("path", {
					d: "m17 14 5 1",
					opacity: ".45"
				})
			] }),
			e === "charging" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				/* @__PURE__ */ (0, q.jsx)("path", { d: "M11 12v6a4 4 0 0 0 8 0v-4a4 4 0 0 1 8 0v9" }),
				/* @__PURE__ */ (0, q.jsx)("path", { d: "M8 9h6v5H8zM10 7v2m2-2v2M25 24h4v6h-4zM27 30v3" }),
				/* @__PURE__ */ (0, q.jsx)("path", {
					d: "m22 20-3 5h4l-3 5",
					opacity: ".5"
				})
			] }),
			e === "light" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				/* @__PURE__ */ (0, q.jsx)("rect", {
					x: "13",
					y: "10",
					width: "14",
					height: "21",
					rx: "6"
				}),
				/* @__PURE__ */ (0, q.jsx)("rect", {
					x: "16",
					y: "13",
					width: "8",
					height: "15",
					rx: "4",
					opacity: ".35"
				}),
				/* @__PURE__ */ (0, q.jsx)("path", {
					d: "M20 5v2m0 27v1M7 20h2m22 0h2M9 9l2 2m18 18 2 2M9 31l2-2m18-18 2-2",
					opacity: ".55"
				})
			] })
		]
	});
}
//#endregion
//#region shopify-build/components/testimonials.tsx
function ce() {
	let [e, t] = (0, G.useState)("");
	return /* @__PURE__ */ (0, q.jsxs)("section", {
		className: "testimonials section",
		"aria-labelledby": "reviews-title",
		children: [
			/* @__PURE__ */ (0, q.jsx)("p", {
				className: "eyebrow",
				children: "THE ORYNOOK COMMUNITY"
			}),
			/* @__PURE__ */ (0, q.jsx)("h2", {
				id: "reviews-title",
				children: "Share your experience."
			}),
			/* @__PURE__ */ (0, q.jsx)("p", {
				className: "reviews-note",
				children: "Tell us about the little difference ORYNOOK makes in your day."
			}),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "review-form-wrap review-form-visible",
				children: [/* @__PURE__ */ (0, q.jsx)("p", { children: "Your feedback is sent to our team for review. Your email will not be published." }), /* @__PURE__ */ (0, q.jsxs)("form", {
					method: "post",
					action: "/contact#review-form",
					id: "review-form",
					children: [
						/* @__PURE__ */ (0, q.jsx)("input", {
							type: "hidden",
							name: "form_type",
							value: "contact"
						}),
						/* @__PURE__ */ (0, q.jsx)("input", {
							type: "hidden",
							name: "utf8",
							value: "✓"
						}),
						/* @__PURE__ */ (0, q.jsx)("input", {
							type: "hidden",
							name: "contact[Subject]",
							value: "Product review"
						}),
						/* @__PURE__ */ (0, q.jsxs)("label", { children: ["Your name", /* @__PURE__ */ (0, q.jsx)("input", {
							name: "contact[name]",
							required: !0,
							maxLength: 80
						})] }),
						/* @__PURE__ */ (0, q.jsxs)("label", { children: ["Email", /* @__PURE__ */ (0, q.jsx)("input", {
							name: "contact[email]",
							type: "email",
							autoComplete: "email",
							required: !0
						})] }),
						/* @__PURE__ */ (0, q.jsxs)("label", { children: ["Product", /* @__PURE__ */ (0, q.jsxs)("select", {
							name: "contact[Product]",
							children: [/* @__PURE__ */ (0, q.jsx)("option", { children: "ORYNOOK Speaker Stand" }), /* @__PURE__ */ (0, q.jsx)("option", { children: "BREYZ Portable Fan" })]
						})] }),
						/* @__PURE__ */ (0, q.jsxs)("label", { children: ["Your rating", /* @__PURE__ */ (0, q.jsxs)("select", {
							name: "contact[Rating]",
							required: !0,
							defaultValue: "",
							children: [/* @__PURE__ */ (0, q.jsx)("option", {
								value: "",
								disabled: !0,
								children: "Select a rating"
							}), [
								5,
								4,
								3,
								2,
								1
							].map((e) => /* @__PURE__ */ (0, q.jsxs)("option", {
								value: e,
								children: [e, " / 5"]
							}, e))]
						})] }),
						/* @__PURE__ */ (0, q.jsxs)("label", {
							className: "review-message",
							children: ["Your experience", /* @__PURE__ */ (0, q.jsx)("textarea", {
								name: "contact[body]",
								required: !0,
								minLength: 10,
								maxLength: 2e3,
								rows: 4
							})]
						}),
						/* @__PURE__ */ (0, q.jsx)("button", {
							type: "submit",
							children: "Send your review"
						}),
						/* @__PURE__ */ (0, q.jsx)("p", {
							role: "status",
							children: e
						})
					]
				})]
			})
		]
	});
}
//#endregion
//#region shopify-build/components/back-to-top.tsx
function le({ hidden: e = !1, raised: t = !1 }) {
	let [n, r] = (0, G.useState)(!1);
	return (0, G.useEffect)(() => {
		let e = () => r(window.scrollY > 240);
		return e(), window.addEventListener("scroll", e, { passive: !0 }), () => window.removeEventListener("scroll", e);
	}, []), e || !n ? null : /* @__PURE__ */ (0, q.jsx)("button", {
		className: `back-to-top${t ? " is-raised" : ""}`,
		"aria-label": "Back to top",
		title: "Back to top",
		onClick: () => window.scrollTo({
			top: 0,
			behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
		}),
		children: /* @__PURE__ */ (0, q.jsx)(ae, {
			size: 18,
			"aria-hidden": "true"
		})
	});
}
//#endregion
//#region shopify-build/components/breyz-faq.tsx
function ue() {
	return /* @__PURE__ */ (0, q.jsxs)("div", {
		className: "contact-faq-column fan-faq-column",
		children: [
			/* @__PURE__ */ (0, q.jsx)("p", {
				className: "label",
				children: "PERSONAL COOLING"
			}),
			/* @__PURE__ */ (0, q.jsx)("h3", { children: "BREYZ Portable Fan" }),
			[
				["How does BREYZ work?", "A brushless motor draws in surrounding air through side vents and directs it through the outlet for personal airflow."],
				["How do I charge it?", "BREYZ recharges via USB-C. Charge before heading out and follow the supplied product instructions."],
				["Where can I wear it?", "Use the clip on a shirt, waistband, pocket edge or bag strap. Keep the air vents clear while in use."],
				["How long does the battery last?", "Up to 18 hours at mid speed. Actual runtime depends on the selected mode and conditions of use."]
			].map(([e, t]) => /* @__PURE__ */ (0, q.jsxs)("details", { children: [/* @__PURE__ */ (0, q.jsxs)("summary", { children: [e, /* @__PURE__ */ (0, q.jsx)(F, { size: 17 })] }), /* @__PURE__ */ (0, q.jsx)("p", { children: t })] }, e)),
			/* @__PURE__ */ (0, q.jsxs)("details", { children: [
				/* @__PURE__ */ (0, q.jsxs)("summary", { children: ["Shipping & returns ", /* @__PURE__ */ (0, q.jsx)(F, { size: 17 })] }),
				/* @__PURE__ */ (0, q.jsx)("p", { children: "Free US shipping on orders over $50. You can request a free return within 60 days of delivery, subject to our policy conditions." }),
				/* @__PURE__ */ (0, q.jsxs)("p", { children: [
					/* @__PURE__ */ (0, q.jsx)("a", {
						href: "/policies/shipping-policy",
						children: "Shipping policy"
					}),
					" · ",
					/* @__PURE__ */ (0, q.jsx)("a", {
						href: "/policies/refund-policy",
						children: "Returns & refunds"
					})
				] })
			] })
		]
	});
}
//#endregion
//#region shopify-build/components/breyz-product.tsx
var Y = [
	"https://cdn.shopify.com/s/files/1/1049/9044/1806/files/hf_20260706_185929_f57d29a1-1695-495a-9d51-67b519bb9a43.png?v=1783366990",
	"https://cdn.shopify.com/s/files/1/1049/9044/1806/files/hf_20260706_185930_4834b1ac-180d-4fee-9f58-044f3ceb66f2.png?v=1783367011",
	"https://cdn.shopify.com/s/files/1/1049/9044/1806/files/hf_20260706_185930_e9823d53-5c73-47b5-9b3c-4e51e0ede62b.png?v=1783367015",
	"https://cdn.shopify.com/s/files/1/1049/9044/1806/files/hf_20260706_185930_958f497d-0640-4e13-9098-404e282f164d.png?v=1783367015"
];
function de({ onAdd: e }) {
	let [t, n] = (0, G.useState)(0), [r, i] = (0, G.useState)(1);
	return /* @__PURE__ */ (0, q.jsxs)("div", {
		className: "breyz-content",
		children: [
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "bz-breadcrumb",
				children: [
					/* @__PURE__ */ (0, q.jsx)("a", {
						href: "/collections/all",
						children: "The collection"
					}),
					/* @__PURE__ */ (0, q.jsx)("span", { children: "/" }),
					"BREYZ"
				]
			}),
			/* @__PURE__ */ (0, q.jsxs)("section", {
				className: "bz-product",
				id: "breyz-product",
				"aria-label": "BREYZ Portable Fan",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "bz-gallery",
					children: [/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "bz-image",
						children: [
							/* @__PURE__ */ (0, q.jsx)("span", {
								className: "bz-tag",
								children: "PERSONAL COOLING / 01"
							}),
							/* @__PURE__ */ (0, q.jsx)("img", {
								src: Y[t],
								alt: `BREYZ portable fan — product view ${t + 1}`,
								fetchPriority: "high"
							}),
							/* @__PURE__ */ (0, q.jsx)("span", {
								className: "bz-image-note",
								children: "Small by design. Ready to go."
							})
						]
					}), /* @__PURE__ */ (0, q.jsxs)("div", {
						className: "bz-thumbs",
						"aria-label": "Product images",
						children: [Y.map((e, r) => /* @__PURE__ */ (0, q.jsx)("button", {
							"aria-label": `View BREYZ image ${r + 1}`,
							"aria-pressed": t === r,
							onClick: () => n(r),
							children: /* @__PURE__ */ (0, q.jsx)("img", {
								src: e,
								alt: ""
							})
						}, e)), /* @__PURE__ */ (0, q.jsxs)("span", { children: [
							"Explore the details",
							/* @__PURE__ */ (0, q.jsx)("br", {}),
							"04 product views"
						] })]
					})]
				}), /* @__PURE__ */ (0, q.jsxs)("div", {
					className: "bz-buy",
					children: [
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "bz-label",
							children: "ORYNOOK / EVERYDAY ESSENTIALS"
						}),
						/* @__PURE__ */ (0, q.jsxs)("h1", { children: [
							"A little breeze.",
							/* @__PURE__ */ (0, q.jsx)("br", {}),
							/* @__PURE__ */ (0, q.jsx)("em", { children: "A better day." })
						] }),
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "bz-product-name",
							children: "BREYZ Portable Fan"
						}),
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "bz-description",
							children: "Your own refreshing airflow, wherever the day takes you. A compact, rechargeable clip-on fan that keeps your hands free and comfort close."
						}),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "bz-price",
							children: ["$24.99 ", /* @__PURE__ */ (0, q.jsx)("span", { children: "USD · One fan" })]
						}),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "bz-benefits",
							children: [
								/* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)(re, { size: 17 }), "Aimable airflow"] }),
								/* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)(O, { size: 17 }), "USB-C charging"] }),
								/* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)(k, { size: 17 }), "Clip-on design"] })
							]
						}),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "bz-purchase",
							children: [/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "bz-quantity",
								children: [
									/* @__PURE__ */ (0, q.jsx)("button", {
										"aria-label": "Decrease BREYZ quantity",
										disabled: r === 1,
										onClick: () => i((e) => e - 1),
										children: /* @__PURE__ */ (0, q.jsx)(H, { size: 16 })
									}),
									/* @__PURE__ */ (0, q.jsx)("output", {
										"aria-live": "polite",
										children: r
									}),
									/* @__PURE__ */ (0, q.jsx)("button", {
										"aria-label": "Increase BREYZ quantity",
										onClick: () => i((e) => e + 1),
										children: /* @__PURE__ */ (0, q.jsx)(F, { size: 16 })
									})
								]
							}), /* @__PURE__ */ (0, q.jsxs)("button", {
								className: "bz-button",
								onClick: () => e(r),
								children: [
									"Add to bag · $",
									(r * 24.99).toFixed(2),
									" ",
									/* @__PURE__ */ (0, q.jsx)(A, { size: 18 })
								]
							})]
						}),
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "bz-shipping",
							children: "Free US shipping on orders over $50."
						}),
						/* @__PURE__ */ (0, q.jsxs)("a", {
							className: "bz-assurance",
							href: "/policies/refund-policy",
							children: [
								/* @__PURE__ */ (0, q.jsx)(R, { size: 19 }),
								/* @__PURE__ */ (0, q.jsxs)("span", { children: ["60-day free returns ", /* @__PURE__ */ (0, q.jsx)("small", { children: "See eligibility and return conditions" })] }),
								/* @__PURE__ */ (0, q.jsx)(x, { size: 17 })
							]
						})
					]
				})]
			}),
			/* @__PURE__ */ (0, q.jsxs)("section", {
				className: "bz-engineering",
				"aria-labelledby": "bz-features",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "bz-section-title",
					children: [
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "bz-label",
							children: "01 / COMFORT, CONSIDERED"
						}),
						/* @__PURE__ */ (0, q.jsxs)("h2", {
							id: "bz-features",
							children: [
								"Good design.",
								/* @__PURE__ */ (0, q.jsx)("br", {}),
								"A breath of fresh air."
							]
						}),
						/* @__PURE__ */ (0, q.jsx)("p", { children: "A concealed fan system draws air through the side vents and directs it through the outlet. Point the breeze where you want it." })
					]
				}), /* @__PURE__ */ (0, q.jsx)("div", {
					className: "bz-feature-list",
					children: [
						[
							re,
							"Directed airflow",
							"A focused stream of air, with a clip-on format that goes with you."
						],
						[
							k,
							"Hands free. Fuss free.",
							"Clip to a shirt, waistband or bag strap and adjust its position for personal comfort."
						],
						[
							O,
							"Recharge. Head out.",
							"USB-C charging makes it easy to power up between everyday outings."
						]
					].map(([e, t, n], r) => {
						let i = e;
						return /* @__PURE__ */ (0, q.jsxs)("article", { children: [
							/* @__PURE__ */ (0, q.jsxs)("span", {
								className: "bz-number",
								children: ["0", r + 1]
							}),
							/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("h3", { children: String(t) }), /* @__PURE__ */ (0, q.jsx)("p", { children: String(n) })] }),
							/* @__PURE__ */ (0, q.jsx)(i, { size: 25 })
						] }, String(t));
					})
				})]
			}),
			/* @__PURE__ */ (0, q.jsxs)("section", {
				className: "bz-everyday",
				"aria-labelledby": "bz-day",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", { children: [
					/* @__PURE__ */ (0, q.jsx)("p", {
						className: "bz-label",
						children: "02 / OUT IN THE EVERYDAY"
					}),
					/* @__PURE__ */ (0, q.jsxs)("h2", {
						id: "bz-day",
						children: [
							"Less to carry.",
							/* @__PURE__ */ (0, q.jsx)("br", {}),
							"More room to enjoy."
						]
					}),
					/* @__PURE__ */ (0, q.jsx)("p", { children: "From the morning commute to an afternoon outside, make a little comfort part of your routine." }),
					/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "bz-scenarios",
						children: [
							/* @__PURE__ */ (0, q.jsx)("span", { children: "01 / On the commute" }),
							/* @__PURE__ */ (0, q.jsx)("span", { children: "02 / A walk outside" }),
							/* @__PURE__ */ (0, q.jsx)("span", { children: "03 / Your next getaway" })
						]
					}),
					/* @__PURE__ */ (0, q.jsxs)("a", {
						href: "#breyz-product",
						className: "bz-text-link",
						children: ["Find your everyday breeze ", /* @__PURE__ */ (0, q.jsx)(x, { size: 18 })]
					})
				] }), /* @__PURE__ */ (0, q.jsxs)("figure", { children: [/* @__PURE__ */ (0, q.jsx)("img", {
					src: Y[2],
					alt: "A closer look at the BREYZ portable fan",
					loading: "lazy"
				}), /* @__PURE__ */ (0, q.jsx)("figcaption", { children: "BREYZ / SMALL THINGS. BETTER DAYS." })] })]
			}),
			/* @__PURE__ */ (0, q.jsxs)("section", {
				className: "bz-performance",
				"aria-labelledby": "bz-performance-title",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "bz-performance-copy",
					children: [
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "bz-label",
							children: "03 / A LITTLE MORE UNDER THE SURFACE"
						}),
						/* @__PURE__ */ (0, q.jsxs)("h2", {
							id: "bz-performance-title",
							children: [
								"Stay out longer.",
								/* @__PURE__ */ (0, q.jsx)("br", {}),
								"Bring your breeze."
							]
						}),
						/* @__PURE__ */ (0, q.jsx)("p", { children: "A small fan with more to give. From focused airflow to time between charges, BREYZ is designed to keep up with your everyday plans." })
					]
				}), /* @__PURE__ */ (0, q.jsxs)("div", {
					className: "bz-performance-specs",
					children: [
						/* @__PURE__ */ (0, q.jsxs)("article", { children: [
							/* @__PURE__ */ (0, q.jsx)("span", { children: "AIRFLOW" }),
							/* @__PURE__ */ (0, q.jsxs)("strong", { children: ["4.2 ", /* @__PURE__ */ (0, q.jsx)("small", { children: "m/s" })] }),
							/* @__PURE__ */ (0, q.jsx)("p", { children: "A focused stream, right where you want it." })
						] }),
						/* @__PURE__ */ (0, q.jsxs)("article", { children: [
							/* @__PURE__ */ (0, q.jsx)("span", { children: "TIME TO ROAM" }),
							/* @__PURE__ */ (0, q.jsxs)("strong", { children: [
								/* @__PURE__ */ (0, q.jsx)("small", { children: "up to" }),
								" 18 ",
								/* @__PURE__ */ (0, q.jsx)("small", { children: "h" })
							] }),
							/* @__PURE__ */ (0, q.jsx)("p", { children: "Battery runtime at mid speed." })
						] }),
						/* @__PURE__ */ (0, q.jsxs)("article", { children: [
							/* @__PURE__ */ (0, q.jsx)("span", { children: "A QUIETER MOMENT" }),
							/* @__PURE__ */ (0, q.jsxs)("strong", { children: ["<40 ", /* @__PURE__ */ (0, q.jsx)("small", { children: "dB" })] }),
							/* @__PURE__ */ (0, q.jsx)("p", { children: "Sound level in quiet mode." })
						] }),
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "bz-spec-note",
							children: "Runtime and sound level depend on the selected mode and conditions of use."
						})
					]
				})]
			})
		]
	});
}
//#endregion
//#region shopify-build/components/brand-hero.tsx
function fe() {
	return /* @__PURE__ */ (0, q.jsxs)("section", {
		className: "brand-campaign",
		"aria-labelledby": "brand-campaign-title",
		children: [
			/* @__PURE__ */ (0, q.jsxs)("picture", { children: [/* @__PURE__ */ (0, q.jsx)("source", {
				media: "(min-width: 641px)",
				srcSet: window.__ORYNOOK_ASSET_ROOT__ + "orynook-campaign-wide.png"
			}), /* @__PURE__ */ (0, q.jsx)("img", {
				className: "brand-campaign-image",
				src: window.__ORYNOOK_ASSET_ROOT__ + "orynook-brand-campaign-stand-first.png",
				alt: "ORYNOOK speaker stand and BREYZ portable fan surrounded by flowing light trails",
				fetchPriority: "high"
			})] }),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "brand-campaign-copy",
				children: [
					/* @__PURE__ */ (0, q.jsx)("p", { children: "ORYNOOK / EVERYDAY, UPGRADED" }),
					/* @__PURE__ */ (0, q.jsxs)("h1", {
						id: "brand-campaign-title",
						children: [
							"Small gadgets.",
							/* @__PURE__ */ (0, q.jsx)("br", {}),
							"Better days."
						]
					}),
					/* @__PURE__ */ (0, q.jsxs)("span", { children: [
						"Sound, comfort and a little more ease.",
						/* @__PURE__ */ (0, q.jsx)("br", {}),
						"Thoughtful essentials for your everyday."
					] }),
					/* @__PURE__ */ (0, q.jsxs)("a", {
						href: "/collections/all",
						children: ["Explore the collection ", /* @__PURE__ */ (0, q.jsx)(x, { size: 18 })]
					})
				]
			}),
			/* @__PURE__ */ (0, q.jsx)("div", {
				className: "brand-campaign-caption",
				children: "TWO ESSENTIALS. ENDLESS LITTLE MOMENTS."
			})
		]
	});
}
//#endregion
//#region shopify-build/components/tech-backdrop.tsx
function pe() {
	return /* @__PURE__ */ (0, q.jsxs)("svg", {
		className: "tech-backdrop",
		viewBox: "0 0 1000 620",
		preserveAspectRatio: "none",
		"aria-hidden": "true",
		children: [
			/* @__PURE__ */ (0, q.jsxs)("g", {
				className: "tech-orbits",
				children: [
					/* @__PURE__ */ (0, q.jsx)("ellipse", {
						cx: "500",
						cy: "410",
						rx: "245",
						ry: "66"
					}),
					/* @__PURE__ */ (0, q.jsx)("ellipse", {
						cx: "500",
						cy: "410",
						rx: "275",
						ry: "84",
						strokeDasharray: "1 7"
					}),
					/* @__PURE__ */ (0, q.jsx)("path", { d: "M40 275 310 410 80 525 M960 275 690 410 920 525 M65 405 310 425 M935 405 690 425" }),
					/* @__PURE__ */ (0, q.jsx)("path", { d: "M315 476 H685 L715 486 H285 Z M330 488 H670 L695 501 H305 Z" })
				]
			}),
			/* @__PURE__ */ (0, q.jsx)("g", {
				className: "tech-nodes",
				children: [
					[150, 330],
					[850, 330],
					[105, 409],
					[895, 409],
					[265, 478],
					[735, 478]
				].map(([e, t], n) => /* @__PURE__ */ (0, q.jsx)("circle", {
					cx: e,
					cy: t,
					r: "2"
				}, n))
			}),
			/* @__PURE__ */ (0, q.jsxs)("g", {
				className: "tech-tiles",
				children: [
					/* @__PURE__ */ (0, q.jsx)("rect", {
						x: "285",
						y: "280",
						width: "19",
						height: "19",
						rx: "3"
					}),
					/* @__PURE__ */ (0, q.jsx)("rect", {
						x: "696",
						y: "280",
						width: "19",
						height: "19",
						rx: "3"
					}),
					/* @__PURE__ */ (0, q.jsx)("rect", {
						x: "350",
						y: "535",
						width: "13",
						height: "13",
						rx: "2"
					})
				]
			}),
			/* @__PURE__ */ (0, q.jsxs)("g", {
				className: "tech-geometry",
				children: [
					/* @__PURE__ */ (0, q.jsx)("path", { d: "M205 310 l19 -11 19 11 v22 l-19 11 -19 -11 Z M772 465 l14 -8 14 8 v16 l-14 8 -14 -8 Z" }),
					/* @__PURE__ */ (0, q.jsx)("circle", {
						cx: "795",
						cy: "300",
						r: "26",
						strokeDasharray: "30 9 4 9"
					}),
					/* @__PURE__ */ (0, q.jsx)("circle", {
						cx: "795",
						cy: "300",
						r: "18",
						strokeDasharray: "2 5"
					}),
					/* @__PURE__ */ (0, q.jsx)("path", { d: "M180 470 h-12 v25 h25 M820 370 h12 v-25 h-25 M385 525 h35 m5 0 h8 m5 0 h3 M610 315 h18 m5 0 h4" }),
					/* @__PURE__ */ (0, q.jsx)("path", { d: "M150 350 v20 h35 l12 12 M850 435 v20 h-25 l-12 12" })
				]
			}),
			/* @__PURE__ */ (0, q.jsxs)("g", {
				className: "tech-sparks",
				children: [
					/* @__PURE__ */ (0, q.jsx)("path", { d: "M325 350 h8 m-4 -4 v8 M675 520 h8 m-4 -4 v8 M740 355 h6 m-3 -3 v6" }),
					/* @__PURE__ */ (0, q.jsx)("circle", {
						cx: "185",
						cy: "370",
						r: "2"
					}),
					/* @__PURE__ */ (0, q.jsx)("circle", {
						cx: "825",
						cy: "455",
						r: "2"
					})
				]
			})
		]
	});
}
//#endregion
//#region shopify-build/components/product-hero.tsx
function me() {
	let e = (0, G.useRef)(null), t = (0, G.useRef)(null), n = (0, G.useRef)(null), r = (0, G.useRef)(null), [i, a] = (0, G.useState)(!1);
	return (0, G.useEffect)(() => {
		let i = !1, o = () => {};
		async function s() {
			let s = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.i), { OrbitControls: c } = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.r), { RoundedBoxGeometry: l } = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.t), { RoomEnvironment: u } = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.n);
			if (i || !e.current) return;
			let d = e.current, f;
			try {
				f = new s.WebGLRenderer({
					alpha: !0,
					antialias: !0,
					powerPreference: "low-power"
				});
			} catch {
				return;
			}
			f.setPixelRatio(Math.min(window.devicePixelRatio, 2)), f.setClearColor(0, 0), f.shadowMap.enabled = !0, f.shadowMap.type = s.PCFSoftShadowMap, f.outputColorSpace = s.SRGBColorSpace, f.toneMapping = s.ACESFilmicToneMapping, f.toneMappingExposure = 1.05, d.appendChild(f.domElement);
			let p = new s.Scene(), m = new s.PerspectiveCamera(35, 1, .1, 60), h = new u(), g = new s.PMREMGenerator(f), _ = g.fromScene(h, .04);
			p.environment = _.texture, p.environmentIntensity = .45, h.dispose(), g.dispose(), m.position.set(-3.6, 2.8, 6.5);
			let v = new c(m, f.domElement);
			v.target.set(0, 1.15, 0), v.enablePan = !1, v.enableDamping = !0, v.dampingFactor = .085, v.minDistance = 4.8, v.maxDistance = 10, v.enableZoom = !1, v.zoomSpeed = .5, v.minPolarAngle = .12, v.maxPolarAngle = Math.PI - .12, v.rotateSpeed = .65, f.domElement.style.touchAction = "pan-y";
			let y = new s.Group();
			p.add(y), y.scale.setScalar(.86), y.position.y = .02;
			let b = new s.MeshPhysicalMaterial({
				color: 1711134,
				roughness: .48,
				metalness: .05,
				clearcoat: .06,
				clearcoatRoughness: .5
			}), x = new s.MeshStandardMaterial({
				color: 1052947,
				roughness: .78,
				metalness: 0
			}), S = new s.MeshStandardMaterial({
				color: 13685202,
				roughness: .3,
				metalness: .9
			}), C = new s.MeshStandardMaterial({
				color: 6643832,
				metalness: .75,
				roughness: .23
			}), w = (e, t, n, r, i, a, o, c, u) => {
				let d = new l(e, t, n, 4, r);
				if (t > 2 && n < .2) {
					d.dispose();
					let i = new s.Shape();
					i.moveTo(-e / 2 + r, -t / 2), i.lineTo(e / 2 - r, -t / 2), i.quadraticCurveTo(e / 2, -t / 2, e / 2, -t / 2 + r), i.lineTo(e / 2, t / 2 - r), i.quadraticCurveTo(e / 2, t / 2, e / 2 - r, t / 2), i.lineTo(-e / 2 + r, t / 2), i.quadraticCurveTo(-e / 2, t / 2, -e / 2, t / 2 - r), i.lineTo(-e / 2, -t / 2 + r), i.quadraticCurveTo(-e / 2, -t / 2, -e / 2 + r, -t / 2), d = new s.ExtrudeGeometry(i, {
						depth: n,
						bevelEnabled: !1,
						curveSegments: 16,
						steps: 1
					}), d.translate(0, 0, -n / 2);
					let a = d.getAttribute("position"), o = d.getAttribute("uv");
					for (let n = 0; n < a.count; n++) o.setXY(n, a.getX(n) / e + .5, a.getY(n) / t + .5);
				}
				let f = new s.Mesh(d, i);
				return f.position.set(o, c, u), f.castShadow = !0, f.receiveShadow = !0, a.add(f), f;
			};
			w(1.98, .12, 1.8, .055, b, y, 0, .2, 0);
			for (let e of [-.72, .72]) for (let t of [-.58, .62]) w(.28, .045, .31, .035, x, y, e, .126, t);
			let T = new s.Shape();
			T.moveTo(-.75, .27), T.lineTo(.63, .27), T.quadraticCurveTo(.77, .29, .64, .5), T.lineTo(.04, 1.96), T.quadraticCurveTo(-.06, 2.08, -.15, 1.94), T.lineTo(-.75, .4), T.closePath();
			let ee = new s.ExtrudeGeometry(T, {
				depth: .085,
				bevelEnabled: !0,
				bevelSegments: 3,
				steps: 1,
				bevelSize: .035,
				bevelThickness: .025
			});
			for (let e of [-.89, .89]) {
				let t = new s.Mesh(ee, b);
				t.rotation.y = Math.PI / 2, t.position.x = e - .04, t.castShadow = !0, y.add(t);
				let n = new s.Mesh(new s.CylinderGeometry(.18, .18, .12, 48), S);
				n.rotation.z = Math.PI / 2, n.position.set(e, 1.82, .02), y.add(n);
				let r = new s.Mesh(new s.CylinderGeometry(.148, .148, .128, 64), S);
				r.rotation.z = Math.PI / 2, r.position.copy(n.position), y.add(r);
				let i = new s.Mesh(new s.TorusGeometry(.167, .009, 8, 64), x);
				i.rotation.y = Math.PI / 2, i.position.set(e + Math.sign(e) * .061, 1.82, .02), y.add(i);
			}
			let E = new s.Group();
			E.position.set(0, 1.82, .02), E.rotation.x = -.16, y.add(E), w(1.65, 1.72, .76, .17, b, E, 0, 0, 0), w(1.58, 1.65, .028, .15, x, E, 0, 0, .389), w(1.43, 1.5, .025, .12, x, E, 0, 0, -.4), w(1.38, 1.44, .024, .095, new s.MeshStandardMaterial({
				color: 3421753,
				metalness: .32,
				roughness: .55
			}), E, 0, 0, -.424);
			let te = new s.InstancedMesh(new s.CircleGeometry(.017, 10), new s.MeshBasicMaterial({ color: 131844 }), 552), ne = new s.Object3D(), re = 0;
			for (let e = 0; e < 24; e++) for (let t = 0; t < 23; t++) ne.position.set((t - 11) * .054 + e % 2 * .02, (e - 11.5) * .051, -.438), ne.rotation.y = Math.PI, ne.updateMatrix(), te.setMatrixAt(re++, ne.matrix);
			E.add(te);
			for (let e = 0; e < 4; e++) w(.19, .035, .15, .035, x, E, (e - 1.5) * .29, .873, -.04);
			w(.035, .17, .25, .018, x, E, -.845, .12, .04), w(.065, .085, .15, .018, S, E, -.87, .12, .04), w(.22, .145, .23, .028, x, E, -.99, .12, .04);
			for (let e = 0; e < 3; e++) w(.027, .11, .17, .01, b, E, -1.12 - e * .035, .12, .04);
			let D = .8, O = .845, k = .16, A = new s.Path();
			A.moveTo(-D + k, O), A.lineTo(D - k, O), A.quadraticCurveTo(D, O, D, O - k), A.lineTo(D, -O + k), A.quadraticCurveTo(D, -O, D - k, -O), A.lineTo(-D + k, -O), A.quadraticCurveTo(-D, -O, -D, -O + k), A.lineTo(-D, O - k), A.quadraticCurveTo(-D, O, -D + k, O);
			let ie = A.getSpacedPoints(256).slice(0, -1).map((e) => new s.Vector3(e.x, e.y, .416)), j = new s.TubeGeometry(new s.CatmullRomCurve3(ie, !0), 256, .022, 8, !0), M = [], N = j.getAttribute("position");
			for (let e = 0; e < N.count; e++) {
				let t = new s.Color().setHSL((Math.atan2(N.getY(e), N.getX(e)) / (Math.PI * 2) + 1) % 1, 1, .5);
				M.push(t.r, t.g, t.b);
			}
			j.setAttribute("color", new s.Float32BufferAttribute(M, 3)), E.add(new s.Mesh(j, new s.MeshBasicMaterial({
				vertexColors: !0,
				toneMapped: !1
			})));
			let ae = E.children.length;
			w(1.4, 2.82, .115, .15, C, E, 0, .43, .53), w(1.34, 2.75, .03, .14, x, E, 0, .43, .597);
			let P = document.createElement("canvas");
			P.width = 600, P.height = 1200;
			let F = P.getContext("2d"), I = F.createLinearGradient(0, 0, 600, 1200);
			I.addColorStop(0, "#0c1236"), I.addColorStop(.65, "#292054"), I.addColorStop(1, "#100f25"), F.fillStyle = I, F.fillRect(0, 0, 600, 1200);
			for (let e = 6; e > 0; e--) F.beginPath(), F.arc(300, 505, e * 33, 0, Math.PI * 2), F.strokeStyle = `rgba(162,121,255,${.1 + (6 - e) * .035})`, F.lineWidth = 9, F.stroke();
			F.fillStyle = "#d4baff", F.font = "90px sans-serif", F.textAlign = "center", F.fillText("♫", 300, 535), F.strokeStyle = "#a994d8", F.lineWidth = 3, F.beginPath(), F.moveTo(120, 905), F.lineTo(480, 905), F.stroke(), F.fillStyle = "#ece4fa", F.beginPath(), F.arc(230, 905, 7, 0, Math.PI * 2), F.fill(), F.fillRect(285, 975, 9, 35), F.fillRect(308, 975, 9, 35), F.fillStyle = "#020309", F.beginPath(), F.roundRect(207, 30, 186, 43, 22), F.fill();
			let L = new Image();
			L.onload = () => {
				i || (F.fillStyle = "#050509", F.fillRect(0, 0, 600, 1200), F.save(), F.translate(300, 600), F.rotate(Math.PI / 2), F.drawImage(L, -590, -290, 1180, 580), F.restore(), R.needsUpdate = !0);
			}, L.src = window.__ORYNOOK_ASSET_ROOT__ + "bedtime-film.webp";
			let R = new s.CanvasTexture(P);
			R.colorSpace = s.SRGBColorSpace, w(1.265, 2.65, .012, .12, new s.MeshBasicMaterial({ map: R }), E, 0, .43, .618), w(.32, .38, .065, .08, C, E, -.42, 1.49, .445);
			for (let e of [1.4, 1.57]) {
				let t = new s.Mesh(new s.CylinderGeometry(.065, .065, .04, 24), x);
				t.rotation.x = Math.PI / 2, t.position.set(-.42, e, .399), E.add(t);
			}
			let z = new s.Group();
			z.position.set(0, -.19, 0), E.add(z);
			for (let e of E.children.slice(ae, -1)) e.position.y -= .43, z.add(e);
			z.rotation.z = Math.PI / 2;
			for (let e of [-.49, .49]) w(.27, .12, .3, .045, b, E, e, -.98, .5), w(.27, .19, .09, .035, x, E, e, -.91, .66);
			y.updateMatrixWorld(!0);
			let oe = new s.Vector3(-1.21, .12, .04).applyMatrix4(E.matrix), B = new s.Vector3(1.45, -.19, .54).applyMatrix4(E.matrix);
			w(.19, .16, .2, .025, x, E, 1.43, -.19, .54);
			let V = new s.CatmullRomCurve3([
				oe,
				new s.Vector3(-1.4, 1.77, .12),
				new s.Vector3(-1.6, .3, .68),
				new s.Vector3(-1.35, .16, 1.05),
				new s.Vector3(.85, .16, 1.15),
				new s.Vector3(1.65, .4, .83),
				new s.Vector3(1.7, 1.3, .66),
				B
			]), H = new s.Mesh(new s.TubeGeometry(V, 80, .027, 8, !1), x);
			H.castShadow = !0, y.add(H);
			let U = new s.HemisphereLight(15203071, 1649460, 1.2);
			p.add(U);
			let W = new s.DirectionalLight(16774889, 2.8);
			W.position.set(-3, 7, 5), W.castShadow = !0, W.shadow.mapSize.set(2048, 2048), W.shadow.camera.left = -4, W.shadow.camera.right = 4, W.shadow.camera.top = 5, W.shadow.camera.bottom = -4, W.shadow.normalBias = .025, p.add(W);
			let se = new s.DirectionalLight(2282478, 1.3);
			se.position.set(4, 3, -4), p.add(se);
			let G = new s.Mesh(new s.PlaneGeometry(200, 200), new s.ShadowMaterial({ opacity: .13 }));
			G.rotation.x = -Math.PI / 2, G.position.y = .105, G.receiveShadow = !0, p.add(G);
			let K = (e, t, n, r, i, a, o) => ({
				parent: e,
				point: new s.Vector3(t, n, r),
				normal: new s.Vector3(i, a, o)
			}), q = [
				[
					K(E, -.36, .15, -.445, 0, 0, -1),
					K(E, -.83, .35, -.1, -1, 0, 0),
					K(E, .83, .35, -.1, 1, 0, 0)
				],
				[K(E, -.145, .895, -.04, 0, 1, 0)],
				[K(y, -.96, 1.82, .02, -1, 0, 0), K(y, .96, 1.82, .02, 1, 0, 0)],
				[K(E, 1.53, -.19, .54, 1, 0, 0)],
				[K(E, -.64, .845, .43, 0, 0, 1), K(E, .64, .845, .43, 0, 0, 1)]
			], J = new s.Vector3(), ce = new s.Raycaster(), le = new s.Vector3(), ue = [
				0,
				0,
				0,
				0,
				0
			], Y = new s.Vector3(), de = new s.Vector3(), fe = new s.Vector3(), pe = Array.from(n.current?.querySelectorAll("g") || []), me = [], X = {
				x: 0,
				y: 0,
				w: 0,
				h: 0
			}, he = () => {
				if (!t.current || !n.current) return;
				let e = (e) => {
					let n = 0, r = 0, i = e;
					for (; i && i !== t.current;) n += i.offsetLeft, r += i.offsetTop, i = i.offsetParent;
					return {
						left: n,
						top: r,
						width: e.clientWidth,
						height: e.clientHeight,
						right: n + e.clientWidth
					};
				}, r = {
					left: 0,
					top: 0,
					width: t.current.clientWidth,
					height: t.current.clientHeight
				}, i = e(d);
				n.current.setAttribute("viewBox", `0 0 ${r.width} ${r.height}`), X = {
					x: i.left - r.left,
					y: i.top - r.top,
					w: i.width,
					h: i.height
				}, me = Array.from(t.current.querySelectorAll("[data-connector]")).map((t) => {
					let n = e(t), i = t.closest(".core-left") !== null;
					return {
						x: (i ? n.right : n.left) - r.left,
						y: n.top + n.height / 2 - r.top,
						left: i,
						mobile: !1
					};
				});
			}, ge = () => {
				he(), q.forEach((e, t) => {
					let n = me[t], r = pe[t];
					if (!n || !r) return;
					let i = e[0], a = -Infinity;
					e.forEach((e) => {
						Y.copy(e.point), e.parent.localToWorld(Y), de.copy(e.normal).transformDirection(e.parent.matrixWorld), fe.copy(m.position).sub(Y).normalize();
						let t = m.position.distanceTo(Y);
						le.copy(Y).sub(m.position).normalize(), ce.set(m.position, le), ce.far = Math.max(0, t - .055);
						let n = ce.intersectObject(y, !0).length > 0 ? -2 : de.dot(fe);
						n > a && (a = n, i = e);
					});
					let { parent: o, point: c } = i;
					J.copy(c), o.localToWorld(J), J.project(m);
					let l = X.x + (J.x + 1) * X.w / 2, u = X.y + (1 - J.y) * X.h / 2, d = a > -.08 && J.z > -1 && J.z < 1 && Number.isFinite(l) && Number.isFinite(u);
					if (ue[t] = s.MathUtils.lerp(ue[t], +!!d, .16), r.style.opacity = String(ue[t]), !d && ue[t] < .01) return;
					let f = n.mobile ? `M ${n.x} ${n.y} L ${n.x} ${n.y - 12} L ${l} ${u}` : `M ${n.x} ${n.y} L ${n.x + (n.left ? 20 : -20)} ${n.y} L ${l} ${u}`;
					r.querySelector("path")?.setAttribute("d", f);
					let p = r.querySelector("circle");
					p?.setAttribute("cx", String(l)), p?.setAttribute("cy", String(u));
				});
			}, Z = new ResizeObserver(he);
			t.current && (Z.observe(t.current), t.current.querySelectorAll("[data-connector]").forEach((e) => Z.observe(e))), document.fonts.ready.then(() => {
				i || he();
			}), r.current = { reset: () => {
				m.position.set(-3.6, 2.8, 6.5), v.target.set(0, 1.15, 0), v.update();
			} };
			let _e = new s.Raycaster(), Q = null, $ = !1, ve = 0, ye = 0, be = window.matchMedia("(prefers-reduced-motion: reduce)").matches, xe = 35, Se = (e) => {
				let t = f.domElement.getBoundingClientRect();
				_e.setFromCamera(new s.Vector2((e.clientX - t.left) / t.width * 2 - 1, -(e.clientY - t.top) / t.height * 2 + 1), m), Q = {
					x: e.clientX,
					y: e.clientY,
					time: Date.now(),
					hit: _e.intersectObject(y, !0).length > 0
				};
			}, Ce = (e) => {
				$ = !1, Q && Q.hit && Date.now() - Q.time < 450 && Math.hypot(e.clientX - Q.x, e.clientY - Q.y) < 5 && window.location.assign("/products/soundglow-5-in-1-speaker-stand"), Q = null;
			}, we = (e) => {
				if (e.pointerType !== "mouse") return;
				let t = f.domElement.getBoundingClientRect();
				Q && Math.hypot(e.clientX - Q.x, e.clientY - Q.y) > 5 && ($ = !0), Q || (ve = ((e.clientX - t.left) / t.width - .5) * .05, ye = ((e.clientY - t.top) / t.height - .5) * .025);
			}, Te = () => {
				ve = 0, ye = 0;
			};
			f.domElement.addEventListener("pointermove", we), f.domElement.addEventListener("pointerleave", Te);
			let Ee = () => {
				Q = null, $ = !1;
			};
			f.domElement.addEventListener("pointerdown", Se), f.domElement.addEventListener("pointerup", Ce), f.domElement.addEventListener("pointercancel", Ee);
			let De = () => {
				let e = d.clientWidth, t = d.clientHeight;
				f.setSize(e, t), m.aspect = e / t, xe = e < 600 ? 43 : 35, m.fov = xe, m.updateProjectionMatrix();
			}, Oe = new ResizeObserver(De);
			Oe.observe(d), De();
			let ke = !0, Ae = new IntersectionObserver((e) => {
				ke = e[0]?.isIntersecting ?? !1;
			});
			Ae.observe(d), f.setAnimationLoop(() => {
				if (!ke || document.hidden) return;
				let e = xe * ($ ? .9 : 1);
				m.fov = be ? xe : s.MathUtils.lerp(m.fov, e, .075), m.updateProjectionMatrix(), !be && !$ && (y.rotation.y = s.MathUtils.lerp(y.rotation.y, ve, .045), y.rotation.x = s.MathUtils.lerp(y.rotation.x, ye, .045)), v.update(), f.render(p, m), ge();
			}), a(!0), o = () => {
				Ae.disconnect(), Z.disconnect(), r.current = null, L.onload = null, f.domElement.removeEventListener("pointermove", we), f.domElement.removeEventListener("pointerleave", Te), Oe.disconnect(), v.dispose(), f.setAnimationLoop(null), f.domElement.removeEventListener("pointerdown", Se), f.domElement.removeEventListener("pointerup", Ce), f.domElement.removeEventListener("pointercancel", Ee);
				let e = /* @__PURE__ */ new Set();
				p.traverse((t) => {
					t instanceof s.Mesh && (t.geometry.dispose(), (Array.isArray(t.material) ? t.material : [t.material]).forEach((t) => e.add(t)));
				}), e.forEach((e) => e.dispose()), R.dispose(), _.dispose(), f.dispose(), f.domElement.remove();
			};
		}
		return s().catch(() => a(!1)), () => {
			i = !0, o();
		};
	}, []), /* @__PURE__ */ (0, q.jsxs)("section", {
		ref: t,
		className: "immersive-hero core-hero",
		"aria-label": "Explore ORYNOOK in 3D",
		children: [
			/* @__PURE__ */ (0, q.jsx)(pe, {}),
			/* @__PURE__ */ (0, q.jsx)("svg", {
				ref: n,
				className: "product-connectors",
				"aria-hidden": "true",
				style: { visibility: i ? "visible" : "hidden" },
				children: [
					0,
					1,
					2,
					3,
					4
				].map((e) => /* @__PURE__ */ (0, q.jsxs)("g", {
					"data-line": e,
					children: [/* @__PURE__ */ (0, q.jsx)("path", { fill: "none" }), /* @__PURE__ */ (0, q.jsx)("circle", { r: "2.5" })]
				}, e))
			}),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "core-heading",
				children: [
					/* @__PURE__ */ (0, q.jsx)("p", {
						className: "eyebrow",
						children: "// YOUR EVERYDAY, UPGRADED"
					}),
					/* @__PURE__ */ (0, q.jsxs)("h1", { children: [
						"Your space.",
						/* @__PURE__ */ (0, q.jsx)("br", {}),
						"Your ",
						/* @__PURE__ */ (0, q.jsx)("em", { children: "soundtrack." })
					] }),
					/* @__PURE__ */ (0, q.jsxs)("p", {
						className: "core-description",
						children: [
							"Sound, light and hands-free comfort.",
							/* @__PURE__ */ (0, q.jsx)("br", {}),
							"Five everyday essentials. One thoughtful stand."
						]
					})
				]
			}),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "core-orbit",
				children: [
					/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "core-stage",
						children: [/* @__PURE__ */ (0, q.jsx)("div", {
							className: "hero-renderer",
							ref: e
						}), !i && /* @__PURE__ */ (0, q.jsx)("a", {
							className: "hero-fallback",
							href: "/products/soundglow-5-in-1-speaker-stand",
							children: /* @__PURE__ */ (0, q.jsx)("img", {
								src: window.__ORYNOOK_ASSET_ROOT__ + "hero-concept-exclusive.webp",
								alt: "ORYNOOK speaker stand studio visualization"
							})
						})]
					}),
					/* @__PURE__ */ (0, q.jsx)("div", {
						className: "core-features core-left",
						children: [
							[
								ee,
								"INDUCTION AUDIO",
								"Place your phone. Press play."
							],
							[
								w,
								"BLUETOOTH",
								"Your playlists, connected."
							],
							[
								k,
								"ADJUSTABLE STAND",
								"Find your point of view."
							]
						].map(([e, t, n], r) => /* @__PURE__ */ (0, q.jsxs)("a", {
							href: "/products/soundglow-5-in-1-speaker-stand",
							className: "core-feature",
							"data-connector": r,
							children: [/* @__PURE__ */ (0, q.jsx)("span", {
								className: "core-icon",
								children: /* @__PURE__ */ (0, q.jsx)(e, { size: 19 })
							}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: String(t) }), /* @__PURE__ */ (0, q.jsx)("small", { children: String(n) })] })]
						}, String(t)))
					}),
					/* @__PURE__ */ (0, q.jsx)("div", {
						className: "core-features core-right",
						children: [
							[
								O,
								"USB CHARGING",
								"Keep your day powered."
							],
							[
								V,
								"AMBIENT LIGHT",
								"A little color. Your atmosphere."
							],
							[
								R,
								"60-DAY RETURNS",
								"A little extra peace of mind."
							]
						].map(([e, t, n], r) => {
							let i = e;
							return /* @__PURE__ */ (0, q.jsxs)("a", {
								href: r === 2 ? "/policies/refund-policy" : "/products/soundglow-5-in-1-speaker-stand",
								className: "core-feature",
								"data-connector": r < 2 ? r + 3 : void 0,
								children: [/* @__PURE__ */ (0, q.jsx)("span", {
									className: "core-icon",
									children: /* @__PURE__ */ (0, q.jsx)(i, { size: 19 })
								}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: String(t) }), /* @__PURE__ */ (0, q.jsx)("small", { children: String(n) })] })]
							}, String(t));
						})
					})
				]
			}),
			/* @__PURE__ */ (0, q.jsx)("div", {
				className: "core-actions",
				children: /* @__PURE__ */ (0, q.jsxs)("a", {
					className: "cta",
					href: "/products/soundglow-5-in-1-speaker-stand",
					children: ["Explore ORYNOOK ", /* @__PURE__ */ (0, q.jsx)(x, { size: 16 })]
				})
			}),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "hero-3d-caption",
				children: [/* @__PURE__ */ (0, q.jsx)("span", {
					className: "concept-label",
					children: "ORYNOOK / EXPLORE IN 3D"
				}), /* @__PURE__ */ (0, q.jsxs)("span", {
					className: "hero-instruction",
					children: [/* @__PURE__ */ (0, q.jsx)(ie, { size: 14 }), i ? "Drag to explore · Click to discover" : "Explore ORYNOOK"]
				})]
			})
		]
	});
}
//#endregion
//#region shopify-build/components/fan-model.tsx
function X() {
	let e = (0, G.useRef)(null), [t, n] = (0, G.useState)(!1);
	return (0, G.useEffect)(() => {
		let t = !1, r = () => {};
		async function i() {
			let i = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.i), { OrbitControls: a } = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.r), { RoomEnvironment: o } = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.n), { RoundedBoxGeometry: s } = await import("./orynook-three-core-DmFx4m2W.js").then((e) => e.t);
			if (t || !e.current) return;
			let c = e.current, l = new i.Scene(), u = new i.PerspectiveCamera(36, 1, .1, 100);
			u.position.set(2.3, 1.4, 6);
			let d = new i.WebGLRenderer({
				alpha: !0,
				antialias: !0
			});
			d.setPixelRatio(Math.min(devicePixelRatio, 2)), d.setClearColor(0, 0), d.toneMapping = i.ACESFilmicToneMapping, d.toneMappingExposure = .9, c.appendChild(d.domElement), d.domElement.style.touchAction = "pan-y", d.domElement.setAttribute("aria-label", "Drag to rotate BREYZ. Click to open its product page.");
			let f = new i.PMREMGenerator(d), p = new o(), m = f.fromScene(p, .04);
			l.environment = m.texture, p.dispose(), f.dispose();
			let h = document.createElement("canvas");
			h.width = h.height = 128;
			let g = h.getContext("2d"), _ = g.createImageData(128, 128), v = 37;
			for (let e = 0; e < _.data.length; e += 4) {
				v = v * 1664525 + 1013904223 >>> 0;
				let t = 110 + v % 35;
				_.data[e] = _.data[e + 1] = _.data[e + 2] = t, _.data[e + 3] = 255;
			}
			g.putImageData(_, 0, 0);
			let y = new i.CanvasTexture(h);
			y.wrapS = y.wrapT = i.RepeatWrapping, y.repeat.set(5, 5);
			let b = new i.Group();
			l.add(b);
			let x = new i.MeshStandardMaterial({
				color: "#203e37",
				roughness: .64,
				metalness: 0,
				bumpMap: y,
				bumpScale: .004,
				envMapIntensity: .55
			}), S = new i.MeshStandardMaterial({
				color: "#1e3b35",
				roughness: .65
			}), C = new i.MeshPhysicalMaterial({
				color: "#d9b873",
				roughness: .3,
				metalness: 1,
				anisotropy: 0,
				clearcoat: .08,
				envMapIntensity: 1.1
			}), w = new i.MeshStandardMaterial({
				color: "#080e0c",
				roughness: .8
			});
			function T(e, t, n = 0, r = 0, a = 0) {
				let o = new i.Mesh(e, t);
				return o.position.set(n, r, a), b.add(o), o;
			}
			let ee = [
				new i.Vector2(0, -.31),
				new i.Vector2(.79, -.31),
				new i.Vector2(.93, -.25),
				new i.Vector2(1, -.12),
				new i.Vector2(1, .1),
				new i.Vector2(.96, .25),
				new i.Vector2(.86, .34),
				new i.Vector2(.62, .38),
				new i.Vector2(.59, .35),
				new i.Vector2(.59, .27),
				new i.Vector2(0, .27)
			], E = T(new i.LatheGeometry(new i.SplineCurve(ee).getPoints(160), 128), x);
			E.rotation.x = Math.PI / 2;
			let te = [
				new i.Vector2(0, -.024),
				new i.Vector2(.525, -.024),
				new i.Vector2(.55, -.012),
				new i.Vector2(.553, .007),
				new i.Vector2(.54, .024),
				new i.Vector2(.35, .025),
				new i.Vector2(0, .025)
			], ne = T(new i.LatheGeometry(te, 128), C, 0, 0, .335);
			ne.rotation.x = Math.PI / 2, T(new i.TorusGeometry(.595, .065, 16, 96), x, 0, 0, .32);
			for (let e = 0; e < 6; e++) {
				let t = .74 + e * .039, n = [];
				for (let e = 0; e <= 24; e++) {
					let r = -.31 + e / 24 * .62, a = t * Math.cos(r), o = t * Math.sin(r), s = t < .86 ? .384 - (t - .62) * .16 : .346 - (t - .86) * .9;
					n.push(new i.Vector3(a, o, s));
				}
				T(new i.TubeGeometry(new i.CatmullRomCurve3(n), 24, .0105, 8, !1), w);
			}
			T(new i.TorusGeometry(.985, .009, 8, 96), S, 0, 0, -.04);
			let re = T(new i.CylinderGeometry(.82, .82, .025, 80), x, 0, 0, -.31);
			re.rotation.x = Math.PI / 2;
			let D = new i.CatmullRomCurve3([
				new i.Vector3(0, .77, -.18),
				new i.Vector3(0, 1.17, -.2),
				new i.Vector3(0, 1.25, -.46),
				new i.Vector3(0, 1.03, -.62),
				new i.Vector3(0, -.65, -.63)
			]), O = new i.Shape();
			O.moveTo(-.21, -.035), O.lineTo(.21, -.035), O.quadraticCurveTo(.24, -.035, .24, 0), O.quadraticCurveTo(.24, .035, .21, .035), O.lineTo(-.21, .035), O.quadraticCurveTo(-.24, .035, -.24, 0), O.quadraticCurveTo(-.24, -.035, -.21, -.035), T(new i.ExtrudeGeometry(O, {
				steps: 80,
				bevelEnabled: !1,
				extrudePath: D
			}), x), T(new s(.25, .095, .035, 4, .035), C, .59, -.24, -.345), T(new s(.18, .06, .02, 3, .024), w, .61, .15, -.34), T(new s(.135, .014, .023, 2, .006), S, .61, .15, -.35), T(new i.SphereGeometry(.012, 10, 8), w, .61, .025, -.344), b.updateMatrixWorld(!0);
			let k = new i.Box3().setFromObject(b).getSize(new i.Vector3());
			b.scale.set(2 / k.x, 7.4 / 3.25 / k.y, 5 / 3.25 / k.z), b.userData.dimensionsCm = {
				width: 6.5,
				height: 7.4,
				depth: 5
			}, l.add(new i.HemisphereLight("#e4efdc", "#273b36", .65));
			let A = new i.DirectionalLight("#fff1d6", 2);
			A.position.set(-3, 4, 5), l.add(A);
			let ie = new i.DirectionalLight("#b6d5bf", 2);
			ie.position.set(4, 2, -3), l.add(ie);
			let j = new a(u, d.domElement);
			j.target.set(0, .1, 0), j.enablePan = !1, j.enableZoom = !1, j.enableDamping = !0, j.dampingFactor = .08, j.rotateSpeed = .7, j.update();
			let M = !1, N = !1, ae = 0, P = 0, F = matchMedia("(prefers-reduced-motion: reduce)").matches, I = null, L = new i.Raycaster(), R = (e) => {
				let t = d.domElement.getBoundingClientRect();
				L.setFromCamera(new i.Vector2((e.clientX - t.left) / t.width * 2 - 1, -(e.clientY - t.top) / t.height * 2 + 1), u), I = {
					x: e.clientX,
					y: e.clientY,
					hit: L.intersectObject(b, !0).length > 0
				};
			}, z = (e) => {
				if (I && Math.hypot(e.clientX - I.x, e.clientY - I.y) > 6 && (N = !0), e.pointerType === "mouse" && !I) {
					let t = c.getBoundingClientRect();
					ae = ((e.clientX - t.left) / t.width - .5) * .08, P = ((e.clientY - t.top) / t.height - .5) * .04;
				}
			}, oe = (e) => {
				I?.hit && !N && Math.hypot(e.clientX - I.x, e.clientY - I.y) < 6 && location.assign("/products/breyz-portable-fan"), I = null, N = !1;
			}, B = () => {
				I = null, N = !1, ae = 0, P = 0;
			};
			d.domElement.addEventListener("pointerdown", R), d.domElement.addEventListener("pointermove", z), d.domElement.addEventListener("pointerup", oe), d.domElement.addEventListener("pointercancel", B), d.domElement.addEventListener("pointerleave", B);
			let V = c.closest(".fan-core"), H = "http://www.w3.org/2000/svg", U = document.createElementNS(H, "svg");
			U.setAttribute("class", "fan-feature-connectors"), U.setAttribute("aria-hidden", "true"), V.appendChild(U);
			let W = [...V.querySelectorAll(".core-left .core-feature"), ...V.querySelectorAll(".core-right .core-feature")], se = [
				new i.Vector3(.86, 0, .34),
				new i.Vector3(.59, -.24, -.365),
				new i.Vector3(0, 1.18, -.45),
				new i.Vector3(.61, .15, -.36),
				new i.Vector3(-.4, -.35, -.33)
			], G = se.map(() => {
				let e = document.createElementNS(H, "path"), t = document.createElementNS(H, "circle");
				return t.setAttribute("r", "2.5"), U.appendChild(e), U.appendChild(t), {
					path: e,
					dot: t
				};
			}), K = () => {
				let e = V.getBoundingClientRect(), t = d.domElement.getBoundingClientRect();
				!e.width || !e.height || (U.setAttribute("viewBox", `0 0 ${e.width} ${e.height}`), b.updateMatrixWorld(!0), se.forEach((n, r) => {
					let i = W[r].getBoundingClientRect(), a = b.localToWorld(n.clone()).project(u), o = t.left - e.left + (a.x + 1) * t.width / 2, s = t.top - e.top + (1 - a.y) * t.height / 2, c = r < 3, l = (c ? i.right : i.left) - e.left, d = i.top - e.top + i.height / 2;
					G[r].path.setAttribute("d", `M ${l} ${d} L ${l + (c ? 18 : -18)} ${d} L ${o} ${s}`), G[r].dot.setAttribute("cx", String(o)), G[r].dot.setAttribute("cy", String(s));
				}));
			}, q = () => {
				!c.clientWidth || !c.clientHeight || (d.setSize(c.clientWidth, c.clientHeight), u.aspect = c.clientWidth / c.clientHeight, u.updateProjectionMatrix());
			}, J = new ResizeObserver(q);
			J.observe(c), q();
			let ce = new IntersectionObserver((e) => {
				M = e[0].isIntersecting;
			});
			ce.observe(c), d.setAnimationLoop(() => {
				!M || document.hidden || (F || (b.rotation.y = i.MathUtils.lerp(b.rotation.y, ae, .05), b.rotation.x = i.MathUtils.lerp(b.rotation.x, P, .05), u.fov = i.MathUtils.lerp(u.fov, N ? 33 : 36, .06), u.updateProjectionMatrix()), j.update(), d.render(l, u), K());
			}), n(!0), r = () => {
				U.remove(), J.disconnect(), ce.disconnect(), j.dispose(), d.setAnimationLoop(null), d.domElement.removeEventListener("pointerdown", R), d.domElement.removeEventListener("pointermove", z), d.domElement.removeEventListener("pointerup", oe), d.domElement.removeEventListener("pointercancel", B), d.domElement.removeEventListener("pointerleave", B), b.traverse((e) => {
					e instanceof i.Mesh && e.geometry.dispose();
				}), [
					x,
					S,
					C,
					w
				].forEach((e) => e.dispose()), y.dispose(), m.dispose(), d.dispose(), d.domElement.remove();
			};
		}
		return i().catch(() => n(!1)), () => {
			t = !0, r();
		};
	}, []), /* @__PURE__ */ (0, q.jsx)("div", {
		className: "fan-model",
		ref: e,
		children: !t && /* @__PURE__ */ (0, q.jsx)("img", {
			className: "fan-model-fallback",
			src: window.__ORYNOOK_ASSET_ROOT__ + "breyz-reference.png",
			alt: "BREYZ portable fan"
		})
	});
}
//#endregion
//#region shopify-build/components/product-carousel.tsx
function he() {
	let e = (0, G.useRef)(null), [t, n] = (0, G.useState)(0), [r, i] = (0, G.useState)(!1);
	return (0, G.useEffect)(() => {
		if (r) return;
		let e = setInterval(() => n((e) => 1 - e), 15e3);
		return () => clearInterval(e);
	}, [r, t]), /* @__PURE__ */ (0, q.jsxs)("div", {
		className: `product-carousel slide-${t}`,
		role: "region",
		"aria-roledescription": "carousel",
		"aria-label": "Explore our products",
		onPointerDown: (t) => {
			i(!0), t.target.closest("canvas,a,button") || (e.current = {
				x: t.clientX,
				y: t.clientY
			});
		},
		onPointerUp: (t) => {
			if (e.current) {
				let r = t.clientX - e.current.x, i = t.clientY - e.current.y;
				Math.abs(r) > 60 && Math.abs(r) > Math.abs(i) * 1.3 && n((e) => 1 - e);
			}
			e.current = null, i(!1);
		},
		onPointerCancel: () => i(!1),
		onFocusCapture: () => i(!0),
		onBlurCapture: (e) => {
			e.currentTarget.contains(e.relatedTarget) || i(!1);
		},
		children: [
			/* @__PURE__ */ (0, q.jsx)("div", {
				className: "carousel-light-bridge",
				"aria-hidden": "true",
				children: /* @__PURE__ */ (0, q.jsx)("img", {
					src: window.__ORYNOOK_ASSET_ROOT__ + "orynook-campaign-wide.png",
					alt: ""
				})
			}),
			/* @__PURE__ */ (0, q.jsxs)("div", {
				className: "product-carousel-track",
				children: [/* @__PURE__ */ (0, q.jsx)("div", {
					"aria-hidden": t !== 0,
					inert: t !== 0,
					role: "group",
					"aria-roledescription": "slide",
					"aria-label": "1 of 2 — ORYNOOK Speaker Stand",
					children: /* @__PURE__ */ (0, q.jsx)(me, {})
				}), /* @__PURE__ */ (0, q.jsx)("div", {
					"aria-hidden": t !== 1,
					inert: t !== 1,
					role: "group",
					"aria-roledescription": "slide",
					"aria-label": "2 of 2 — BREYZ Portable Fan",
					children: /* @__PURE__ */ (0, q.jsxs)("section", {
						className: "immersive-hero core-hero fan-core",
						"aria-label": "Explore BREYZ",
						children: [
							/* @__PURE__ */ (0, q.jsx)(pe, {}),
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "core-heading",
								children: [
									/* @__PURE__ */ (0, q.jsx)("p", {
										className: "eyebrow",
										children: "// YOUR EVERYDAY, REFRESHED"
									}),
									/* @__PURE__ */ (0, q.jsxs)("h2", { children: [
										"Your day.",
										/* @__PURE__ */ (0, q.jsx)("br", {}),
										"Your ",
										/* @__PURE__ */ (0, q.jsx)("em", { children: "breeze." })
									] }),
									/* @__PURE__ */ (0, q.jsxs)("p", {
										className: "core-description",
										children: [
											"Personal airflow. A little more comfort.",
											/* @__PURE__ */ (0, q.jsx)("br", {}),
											"One small fan, ready to go."
										]
									})
								]
							}),
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "core-orbit",
								children: [
									/* @__PURE__ */ (0, q.jsx)("div", {
										className: "core-stage fan-core-stage",
										children: /* @__PURE__ */ (0, q.jsx)(X, {})
									}),
									/* @__PURE__ */ (0, q.jsx)("div", {
										className: "core-features core-left",
										children: [
											[
												re,
												"DIRECTED AIRFLOW",
												"A breeze where you need it."
											],
											[
												oe,
												"QUIET MODE",
												"Under 40 dB in quiet mode."
											],
											[
												j,
												"CLIP-ON DESIGN",
												"Keep your hands free."
											]
										].map(([e, t, n]) => /* @__PURE__ */ (0, q.jsxs)("a", {
											href: "/products/breyz-portable-fan",
											className: "core-feature",
											children: [/* @__PURE__ */ (0, q.jsx)("span", {
												className: "core-icon",
												children: /* @__PURE__ */ (0, q.jsx)(e, { size: 19 })
											}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: String(t) }), /* @__PURE__ */ (0, q.jsx)("small", { children: String(n) })] })]
										}, String(t)))
									}),
									/* @__PURE__ */ (0, q.jsx)("div", {
										className: "core-features core-right",
										children: [
											[
												O,
												"USB-C CHARGING",
												"Recharge for your next outing."
											],
											[
												C,
												"UP TO 18 HOURS",
												"Runtime at mid speed."
											],
											[
												R,
												"60-DAY RETURNS",
												"A little extra peace of mind."
											]
										].map(([e, t, n], r) => /* @__PURE__ */ (0, q.jsxs)("a", {
											href: r === 2 ? "/policies/refund-policy" : "/products/breyz-portable-fan",
											className: "core-feature",
											children: [/* @__PURE__ */ (0, q.jsx)("span", {
												className: "core-icon",
												children: /* @__PURE__ */ (0, q.jsx)(e, { size: 19 })
											}), /* @__PURE__ */ (0, q.jsxs)("span", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: String(t) }), /* @__PURE__ */ (0, q.jsx)("small", { children: String(n) })] })]
										}, String(t)))
									})
								]
							}),
							/* @__PURE__ */ (0, q.jsx)("div", {
								className: "core-actions",
								children: /* @__PURE__ */ (0, q.jsxs)("a", {
									className: "cta",
									href: "/products/breyz-portable-fan",
									children: ["Explore BREYZ ", /* @__PURE__ */ (0, q.jsx)(x, { size: 16 })]
								})
							}),
							/* @__PURE__ */ (0, q.jsx)("div", {
								className: "hero-3d-caption",
								children: /* @__PURE__ */ (0, q.jsx)("span", {
									className: "hero-instruction",
									children: "Drag to explore · Click to discover"
								})
							})
						]
					})
				})]
			}),
			/* @__PURE__ */ (0, q.jsxs)("svg", {
				className: "carousel-flow",
				viewBox: "0 0 1400 620",
				preserveAspectRatio: "none",
				"aria-hidden": "true",
				children: [/* @__PURE__ */ (0, q.jsx)("defs", { children: /* @__PURE__ */ (0, q.jsxs)("linearGradient", {
					id: "carousel-river",
					children: [
						/* @__PURE__ */ (0, q.jsx)("stop", { stopColor: "#ff617e" }),
						/* @__PURE__ */ (0, q.jsx)("stop", {
							offset: ".2",
							stopColor: "#ffc65c"
						}),
						/* @__PURE__ */ (0, q.jsx)("stop", {
							offset: ".4",
							stopColor: "#79ed9c"
						}),
						/* @__PURE__ */ (0, q.jsx)("stop", {
							offset: ".6",
							stopColor: "#58dfff"
						}),
						/* @__PURE__ */ (0, q.jsx)("stop", {
							offset: ".8",
							stopColor: "#8c85ff"
						}),
						/* @__PURE__ */ (0, q.jsx)("stop", {
							offset: "1",
							stopColor: "#ec72dc"
						})
					]
				}) }), [
					0,
					1,
					2,
					3,
					4
				].map((e) => /* @__PURE__ */ (0, q.jsxs)("g", {
					transform: `translate(0 ${e * 8})`,
					children: [/* @__PURE__ */ (0, q.jsx)("path", {
						className: "flow-bed",
						d: "M-120 255 C130 260 130 440 420 355 S810 225 1080 360 S1400 450 1530 240"
					}), /* @__PURE__ */ (0, q.jsx)("path", {
						className: "flow-current",
						transform: `translate(0 ${[
							-230,
							-125,
							0,
							85,
							170
						][e] - e * 8})`,
						style: { animationDelay: `-${e * 1.7}s` },
						d: "M-120 255 C130 260 130 440 420 355 S810 225 1080 360 S1400 450 1530 240"
					})]
				}, e))]
			}),
			/* @__PURE__ */ (0, q.jsx)("button", {
				className: "carousel-arrow carousel-prev",
				"aria-label": "Previous product",
				onClick: () => n((e) => 1 - e),
				children: /* @__PURE__ */ (0, q.jsx)(T, { size: 19 })
			}),
			/* @__PURE__ */ (0, q.jsxs)("span", {
				className: "carousel-position",
				"aria-live": "polite",
				children: [
					"0",
					t + 1,
					" / 02"
				]
			}),
			/* @__PURE__ */ (0, q.jsx)("button", {
				className: "carousel-arrow carousel-next",
				"aria-label": "Next product",
				onClick: () => n((e) => 1 - e),
				children: /* @__PURE__ */ (0, q.jsx)(N, { size: 19 })
			})
		]
	});
}
//#endregion
//#region shopify-build/components/ambient-lines.tsx
function ge() {
	return /* @__PURE__ */ (0, q.jsxs)("div", {
		className: "ambient-rgb",
		"aria-hidden": "true",
		children: [
			/* @__PURE__ */ (0, q.jsx)("img", {
				className: "rgb-left",
				src: window.__ORYNOOK_ASSET_ROOT__ + "rgb-ambient-lines.svg",
				alt: ""
			}),
			/* @__PURE__ */ (0, q.jsx)("img", {
				className: "rgb-right",
				src: window.__ORYNOOK_ASSET_ROOT__ + "rgb-ambient-lines.svg",
				alt: ""
			}),
			/* @__PURE__ */ (0, q.jsx)("img", {
				className: "rgb-flow",
				src: window.__ORYNOOK_ASSET_ROOT__ + "rgb-ambient-flow.svg",
				alt: ""
			})
		]
	});
}
//#endregion
//#region shopify-build/components/announcement.tsx
var Z = [
	"Free US shipping on orders over $50",
	"Sound, light & hands-free comfort. All in one stand.",
	"Make it yours — Black or White, just $34.99",
	"Your space. Your soundtrack. Meet ORYNOOK.",
	"Two ways to play — induction audio & Bluetooth",
	"Find your angle. Set the mood with ambient light."
];
function _e() {
	let [e, t] = (0, G.useState)(0), [n, r] = (0, G.useState)(!1), [i, a] = (0, G.useState)(!1), [o, s] = (0, G.useState)(!0);
	(0, G.useEffect)(() => {
		let e = window.matchMedia("(prefers-reduced-motion: reduce)"), t = () => s(e.matches);
		return t(), e.addEventListener("change", t), () => e.removeEventListener("change", t);
	}, []), (0, G.useEffect)(() => {
		if (n || i || o) return;
		let e = window.setInterval(() => t((e) => (e + 1) % Z.length), 5e3);
		return () => window.clearInterval(e);
	}, [
		n,
		i,
		o
	]);
	let c = (e) => t((t) => (t + e + Z.length) % Z.length);
	return /* @__PURE__ */ (0, q.jsx)("section", {
		className: "announcement-rotator",
		"aria-label": "Store highlights",
		onMouseEnter: () => r(!0),
		onMouseLeave: () => r(!1),
		onFocusCapture: () => a(!0),
		onBlurCapture: (e) => {
			e.currentTarget.contains(e.relatedTarget) || a(!1);
		},
		children: /* @__PURE__ */ (0, q.jsxs)("div", {
			className: "announcement-inner",
			children: [
				/* @__PURE__ */ (0, q.jsx)("button", {
					onClick: () => c(-1),
					"aria-label": "Previous announcement",
					children: /* @__PURE__ */ (0, q.jsx)(S, { size: 15 })
				}),
				/* @__PURE__ */ (0, q.jsx)("div", {
					className: "announcement-message",
					"aria-live": "off",
					children: /* @__PURE__ */ (0, q.jsx)("p", { children: Z[e] }, e)
				}),
				/* @__PURE__ */ (0, q.jsx)("button", {
					onClick: () => c(1),
					"aria-label": "Next announcement",
					children: /* @__PURE__ */ (0, q.jsx)(E, { size: 15 })
				})
			]
		})
	});
}
//#endregion
//#region shopify-build/lib/utils.ts
function Q(...e) {
	return I(z(e));
}
//#endregion
//#region shopify-build/components/ui/button.tsx
var $ = B("group/button inline-flex shrink-0 items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/80",
			outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_5%)] aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
			ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
			destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-8 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
			sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
			lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			icon: "size-8",
			"icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
			"icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
			"icon-lg": "size-9"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function ve({ className: e, variant: t = "default", size: n = "default", ...r }) {
	return /* @__PURE__ */ (0, q.jsx)(u, {
		"data-slot": "button",
		className: Q($({
			variant: t,
			size: n,
			className: e
		})),
		...r
	});
}
//#endregion
//#region shopify-build/components/ui/sheet.tsx
function ye({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(o, {
		"data-slot": "sheet",
		...e
	});
}
function be({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(v, {
		"data-slot": "sheet-trigger",
		...e
	});
}
function xe({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(m, {
		"data-slot": "sheet-portal",
		...e
	});
}
function Se({ className: e, ...n }) {
	return /* @__PURE__ */ (0, q.jsx)(t, {
		"data-slot": "sheet-overlay",
		className: Q("bg-black/10 supports-backdrop-filter:backdrop-blur-xs fixed inset-0 z-50 transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0", e),
		...n
	});
}
function Ce({ className: e, children: t, side: n = "right", showCloseButton: r = !0, ...i }) {
	return /* @__PURE__ */ (0, q.jsxs)(xe, { children: [/* @__PURE__ */ (0, q.jsx)(Se, {}), /* @__PURE__ */ (0, q.jsxs)(d, {
		"data-slot": "sheet-content",
		"data-side": n,
		className: Q("bg-popover text-popover-foreground fixed z-50 flex flex-col gap-4 bg-clip-padding text-sm shadow-lg transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm data-ending-style:opacity-0 data-starting-style:opacity-0 data-[side=bottom]:data-ending-style:translate-y-[2.5rem] data-[side=bottom]:data-starting-style:translate-y-[2.5rem] data-[side=left]:data-ending-style:translate-x-[-2.5rem] data-[side=left]:data-starting-style:translate-x-[-2.5rem] data-[side=right]:data-ending-style:translate-x-[2.5rem] data-[side=right]:data-starting-style:translate-x-[2.5rem] data-[side=top]:data-ending-style:translate-y-[-2.5rem] data-[side=top]:data-starting-style:translate-y-[-2.5rem]", e),
		...i,
		children: [t, r && /* @__PURE__ */ (0, q.jsxs)(s, {
			"data-slot": "sheet-close",
			render: /* @__PURE__ */ (0, q.jsx)(ve, {
				variant: "ghost",
				className: "absolute top-3 right-3",
				size: "icon-sm"
			}),
			children: [/* @__PURE__ */ (0, q.jsx)(M, {}), /* @__PURE__ */ (0, q.jsx)("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] });
}
function we({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)("div", {
		"data-slot": "sheet-header",
		className: Q("gap-0.5 p-4 flex flex-col", e),
		...t
	});
}
function Te({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(a, {
		"data-slot": "sheet-title",
		className: Q("text-foreground text-base font-medium cn-font-heading", e),
		...t
	});
}
function Ee({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(c, {
		"data-slot": "sheet-description",
		className: Q("text-muted-foreground text-sm", e),
		...t
	});
}
//#endregion
//#region shopify-build/components/ui/dialog.tsx
function De({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(o, {
		"data-slot": "dialog",
		...e
	});
}
function Oe({ ...e }) {
	return /* @__PURE__ */ (0, q.jsx)(m, {
		"data-slot": "dialog-portal",
		...e
	});
}
function ke({ className: e, ...n }) {
	return /* @__PURE__ */ (0, q.jsx)(t, {
		"data-slot": "dialog-overlay",
		className: Q("fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", e),
		...n
	});
}
function Ae({ className: e, children: t, showCloseButton: n = !0, ...r }) {
	return /* @__PURE__ */ (0, q.jsxs)(Oe, { children: [/* @__PURE__ */ (0, q.jsx)(ke, {}), /* @__PURE__ */ (0, q.jsxs)(d, {
		"data-slot": "dialog-content",
		className: Q("fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...r,
		children: [t, n && /* @__PURE__ */ (0, q.jsxs)(s, {
			"data-slot": "dialog-close",
			render: /* @__PURE__ */ (0, q.jsx)(ve, {
				variant: "ghost",
				className: "absolute top-2 right-2",
				size: "icon-sm"
			}),
			children: [/* @__PURE__ */ (0, q.jsx)(M, {}), /* @__PURE__ */ (0, q.jsx)("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] });
}
function je({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)("div", {
		"data-slot": "dialog-header",
		className: Q("flex flex-col gap-2", e),
		...t
	});
}
function Me({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(a, {
		"data-slot": "dialog-title",
		className: Q("font-heading text-base leading-none font-medium", e),
		...t
	});
}
function Ne({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(c, {
		"data-slot": "dialog-description",
		className: Q("text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground", e),
		...t
	});
}
//#endregion
//#region shopify-build/components/ui/radio-group.tsx
function Pe({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(p, {
		"data-slot": "radio-group",
		className: Q("grid gap-2 w-full", e),
		...t
	});
}
function Fe({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(i, {
		"data-slot": "radio-group-item",
		className: Q("border-input dark:bg-input/30 data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary data-checked:border-primary aria-invalid:aria-checked:border-primary aria-invalid:border-destructive focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 dark:aria-invalid:border-destructive/50 flex size-4 rounded-full focus-visible:ring-3 aria-invalid:ring-3 group-has-[:focus-visible]/field-label:ring-0 group-has-[:focus-visible]/field-label:not-data-checked:border-input group-has-[:focus-visible]/field-label:data-checked:border-primary group/radio-group-item peer relative aspect-square shrink-0 border outline-none after:absolute after:-inset-x-3 after:-inset-y-2 disabled:cursor-not-allowed disabled:opacity-50", e),
		...t,
		children: /* @__PURE__ */ (0, q.jsx)(g, {
			"data-slot": "radio-group-indicator",
			className: "flex size-4 items-center justify-center",
			children: /* @__PURE__ */ (0, q.jsx)("span", { className: "bg-primary-foreground absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full" })
		})
	});
}
//#endregion
//#region shopify-build/components/ui/accordion.tsx
function Ie({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(n, {
		"data-slot": "accordion",
		className: Q("flex w-full flex-col", e),
		...t
	});
}
function Le({ className: e, ...t }) {
	return /* @__PURE__ */ (0, q.jsx)(l, {
		"data-slot": "accordion-item",
		className: Q("not-last:border-b", e),
		...t
	});
}
function Re({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ (0, q.jsx)(h, {
		className: "flex",
		children: /* @__PURE__ */ (0, q.jsxs)(f, {
			"data-slot": "accordion-trigger",
			className: Q("focus-visible:ring-ring/50 focus-visible:border-ring focus-visible:after:border-ring **:data-[slot=accordion-trigger-icon]:text-muted-foreground rounded-lg py-2.5 text-left text-sm font-medium hover:underline focus-visible:ring-3 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 group/accordion-trigger relative flex flex-1 items-start justify-between border border-transparent transition-all outline-none aria-disabled:pointer-events-none aria-disabled:opacity-50", e),
			...n,
			children: [
				t,
				/* @__PURE__ */ (0, q.jsx)(U, {
					"data-slot": "accordion-trigger-icon",
					className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden"
				}),
				/* @__PURE__ */ (0, q.jsx)(W, {
					"data-slot": "accordion-trigger-icon",
					className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline"
				})
			]
		})
	});
}
function ze({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ (0, q.jsx)(_, {
		"data-slot": "accordion-content",
		className: "data-open:animate-accordion-down data-closed:animate-accordion-up text-sm overflow-hidden",
		...n,
		children: /* @__PURE__ */ (0, q.jsx)("div", {
			className: Q("pt-0 pb-2.5 h-(--accordion-panel-height) data-ending-style:h-0 data-starting-style:h-0 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4", e),
			children: t
		})
	});
}
//#endregion
//#region shopify-build/lib/shop-policies.json
var Be = /* @__PURE__ */ JSON.parse("[{\"title\":\"Privacy policy\",\"type\":\"PRIVACY_POLICY\",\"url\":\"https://checkout.shopify.com/104990441806/policies/60848603470.html?locale=en\",\"body\":\"\\n    <div>\\n        <div>\\n  <p>Last updated: July 8, 2026</p>\\n  <p>ORYNOOK operates this store and website, including all related information, content, features, tools, products and services, in order to provide you, the customer, with a curated shopping experience (the  \\\"Services\\\"). ORYNOOK is powered by Shopify, which enables us to provide the Services to you. This Privacy Policy describes how we collect, use, and disclose your personal information when you visit, use, or make a purchase or other transaction using the Services or otherwise communicate with us. If there is a conflict between our Terms of Service and this Privacy Policy, this Privacy Policy controls with respect to the collection, processing, and disclosure of your personal information. </p>\\n  <p>Please read this Privacy Policy carefully. By using and accessing any of the Services, you acknowledge that you have read this Privacy Policy and understand the collection, use, and disclosure of your information as described in this Privacy Policy.</p>\\n  <h2 id=\\\"section-1\\\">Personal Information We Collect or Process</h2>\\n  <p>When we use the term  \\\"personal information,\\\" we are referring to information that identifies or can reasonably be linked to you or another person. Personal information does not include information that is collected anonymously or that has been de-identified, so that it cannot identify or be reasonably linked to you. We may collect or process the following categories of personal information, including inferences drawn from this personal information, depending on how you interact with the Services, where you live, and as permitted or required by applicable law:</p>\\n  <ul>\\n      <li>\\n<strong>Contact details</strong> including your name, address, billing address, shipping address, phone number, and email address.</li>\\n      <li>\\n<strong>Financial information</strong> including credit card, debit card, and financial account numbers, payment card information, financial account information, transaction details, form of payment, payment confirmation and other payment details.</li>\\n      <li>\\n<strong>Account information</strong> including your username, password, security questions, preferences and settings.</li>\\n      <li>\\n<strong>Transaction information</strong> including the items you view, put in your cart, add to your wishlist, or purchase, return, exchange or cancel and your past transactions.</li>\\n      <li>\\n<strong>Communications with us</strong> including the information you include in communications with us, for example, when sending a customer support inquiry.</li>\\n      <li>\\n<strong>Device information</strong> including information about your device, browser, or network connection, your IP address, and other unique identifiers.</li>\\n      <li>\\n<strong>Usage information</strong> including information regarding your interaction with the Services, including how and when you interact with or navigate the Services. </li>\\n  </ul>\\n  <h2 id=\\\"section-2\\\">Personal Information Sources</h2>\\n  <p>We may collect personal information from the following sources:</p>\\n  <ul>\\n      <li>\\n<strong>Directly from you</strong> including when you create an account, visit or use the Services, communicate with us, or otherwise provide us with your personal information;</li>\\n      <li>\\n<strong>Automatically through the Services</strong> including from your device when you use our products or services or visit our websites, and through the use of cookies and similar technologies;</li>\\n      <li>\\n<strong>From our service providers</strong> including when we engage them to enable certain technology and when they collect or process your personal information on our behalf; </li>\\n      <li><strong>From our partners or other third parties.</strong></li>\\n  </ul>\\n  <h2 id=\\\"section-3\\\">How We Use Your Personal Information</h2>\\n  <p>Depending on how you interact with us or which of the Services you use, we may use personal information for the following purposes:</p>\\n  <ul>\\n      <li>\\n<strong>Provide, Tailor, and Improve the Services.</strong> We use your personal information to provide you with the Services, including to perform our contract with you, to process your payments, to fulfill your orders, to remember your preferences and items you are interested in, to send notifications to you related to your account, to process purchases, returns, exchanges or other transactions, to create, maintain and otherwise manage your account, to arrange for shipping, to facilitate any returns and exchanges, to enable you to post reviews, and to create a customized shopping experience for you, such as recommending products related to your purchases. This may include using your personal information to better tailor and improve the Services.</li>\\n      <li>\\n<strong>Marketing and Advertising.</strong> We use your personal information for marketing and promotional purposes, such as to send marketing, advertising and promotional communications by email, text message or postal mail, and to show you online advertisements for products or services on the Services or other websites, including based on items you previously have purchased or added to your cart and other activity on the Services. </li>\\n      <li>\\n<strong>Security and Fraud Prevention.</strong> We use your personal information to authenticate your account, to provide a secure payment and shopping experience, detect, investigate or take action regarding possible fraudulent, illegal, unsafe, or malicious activity, protect public safety, and to secure our services. If you choose to use the Services and register an account, you are responsible for keeping your account credentials safe. We highly recommend that you do not share your username, password or other access details with anyone else.</li>\\n      <li>\\n<strong>Communicating with You.</strong> We use your personal information to provide you with customer support, to be responsive to you, to provide effective services to you and to maintain our business relationship with you. </li>\\n      <li>\\n<strong>Legal Reasons.</strong> We use your personal information to comply with applicable law or respond to valid legal process, including requests from law enforcement or government agencies, to investigate or participate in civil discovery, potential or actual litigation, or other adversarial legal proceedings, and to enforce or investigate potential violations of our terms or policies.</li>\\n  </ul>\\n  <h2 id=\\\"section-4\\\">How We Disclose Personal Information</h2>\\n  <p>In certain circumstances, we may disclose your personal information to third parties for legitimate purposes subject to this Privacy Policy. Such circumstances may include:</p>\\n  <ul>\\n      <li>With Shopify, vendors and other third parties who perform services on our behalf (e.g. IT management, payment processing, data analytics, customer support, cloud storage, fulfillment and shipping).</li>\\n      <li>With business and marketing partners to provide marketing services and advertise to you.  For example, we use Shopify to support personalized advertising with third-party services based on your online activity with different merchants and websites.  Our business and marketing partners will use your information in accordance with their own privacy notices. Depending on where you reside, you may have a right to direct us not to share information about you to show you targeted advertisements and marketing based on your online activity with different merchants and websites. You can exercise your rights to opt-out of those uses <a href=\\\"https://dscommerce-us.com/pages/data-sharing-opt-out\\\"> here</a> .</li>\\n      <li>When you direct, request us or otherwise consent to our disclosure of certain information to third parties, such as to ship you products or through your use of social media widgets or login integrations.</li>\\n      <li>With our affiliates or otherwise within our corporate group.</li>\\n      <li>\\n      In connection with a business transaction such as a merger or bankruptcy, to comply with any applicable legal obligations (including to respond to subpoenas, search warrants and similar requests), to enforce any applicable terms of service or policies, and to protect or defend the Services, our rights, and the rights of our users or others.\\n      </li>\\n  </ul>\\n  <h2 id=\\\"section-5\\\">Relationship with Shopify</h2>\\n  <p>The Services are hosted by Shopify, which collects and processes personal information about your access to and use of the Services in order to provide and improve the Services for you. Information you submit to the Services will be transmitted to and shared with Shopify as well as third parties that may be located in countries other than where you reside, in order to provide and improve the Services for you. In addition, to help protect, grow, and improve our business, we use certain Shopify enhanced features that incorporate data and information obtained from your interactions with our Store, along with other merchants and with Shopify. To provide these enhanced features, Shopify may make use of personal information collected about your interactions with our store, along with other merchants, and with Shopify. In these circumstances, Shopify is responsible for the processing of your personal information, including for responding to your requests to exercise your rights over use of your personal information for these purposes. To learn more about how Shopify uses your personal information and any rights you may have, you can visit the <a href=\\\"https://www.shopify.com/legal/privacy/app-users\\\">Shopify Consumer Privacy Policy</a> . Depending on where you live, you may exercise certain rights with respect to your personal information here <a href=\\\"https://privacy.shopify.com/en\\\">Shopify Privacy Portal Link</a>. </p>\\n  <h2 id=\\\"section-6\\\">Third Party Websites and Links</h2>\\n  <p>The Services may provide links to websites or other online platforms operated by third parties. If you follow links to sites not affiliated or controlled by us, you should review their privacy and security policies and other terms and conditions. We do not guarantee and are not responsible for the privacy or security of such sites, including the accuracy, completeness, or reliability of information found on these sites. Information you provide on public or semi-public venues, including information you share on third-party social networking platforms may also be viewable by other users of the Services and/or users of those third-party platforms without limitation as to its use by us or by a third party. Our inclusion of such links does not, by itself, imply any endorsement of the content on such platforms or of their owners or operators, except as disclosed on the Services.</p>\\n  <h2 id=\\\"section-7\\\">Children's Data</h2>\\n  <p>The Services are not intended to be used by children, and we do not knowingly collect any personal information about children under the age of majority in your jurisdiction. If you are the parent or guardian of a child who has provided us with their personal information, you may contact us using the contact details set out below to request that it be deleted.As of the Effective Date of this Privacy Policy, we do not have actual knowledge that we  \\\"share\\\" or  \\\"sell\\\" (as those terms are defined in applicable law) personal information of individuals under 16 years of age.</p>\\n  <h2 id=\\\"section-8\\\">Security and Retention of Your Information</h2>\\n  <p>Please be aware that no security measures are perfect or impenetrable, and we cannot guarantee \\\"perfect security.\\\" In addition, any information you send to us may not be secure while in transit. We recommend that you do not use unsecure channels to communicate sensitive or confidential information to us.</p>\\n  <p>How long we retain your personal information depends on different factors, such as whether we need the information to maintain your account, to provide you with Services, comply with legal obligations, resolve disputes or enforce other applicable contracts and policies.</p>\\n  <h2 id=\\\"section-9\\\">Your Rights and Choices</h2>\\n  <p>Depending on where you live, you may have some or all of the rights listed below in relation to your personal information. However, these rights are not absolute, may apply only in certain circumstances and, in certain cases, we may decline your request as permitted by law.</p>\\n  <ul>\\n      <li>\\n<strong>Right to Access / Know.</strong> You may have a right to request access to personal information that we hold about you.</li>\\n      <li>\\n<strong>Right to Delete.</strong> You may have a right to request that we delete personal information we maintain about you.</li>\\n      <li>\\n<strong>Right to Correct.</strong> You may have a right to request that we correct inaccurate personal information we maintain about you.</li>\\n      <li>\\n<strong>Right of Portability.</strong> You may have a right to receive a copy of the personal information we hold about you and to request that we transfer it to a third party, in certain circumstances and with certain exceptions.</li>\\n      <li>\\n<strong>Right to Opt out of Sale or Sharing for Targeted Advertising.</strong> Depending on where you reside, you may have a right to opt out of the \\\"sale\\\" or \\\"share\\\" of your personal information or to opt out of the processing of your personal information for purposes considered to be \\\"targeted advertising\\\", as defined in applicable privacy laws. You can exercise your rights to opt-out of those uses <a href=\\\"https://dscommerce-us.com/pages/data-sharing-opt-out\\\">here</a>. Please note that if you visit our website with the Global Privacy Control opt-out preference signal enabled, depending on where you are, we will automatically treat this as a request to opt-out for the device and browser that you use to visit the website. If we are able to associate the device sending the signal to a Shopify account, we will apply the opt out request to the account as well. To learn more about Global Privacy Control, you can visit https://globalprivacycontrol.org/. Other than the Global Privacy Control, we do not recognize other \\\"Do Not Track\\\" signals that may be sent from your web browser or device.</li>\\n      <li>\\n      <strong>Managing Communication Preferences.</strong> We may send you promotional emails, and you may opt out of receiving these at any time by using the unsubscribe option displayed in our emails to you. If you opt out, we may still send you non-promotional emails, such as those about your account or orders that you have made.\\n      </li>\\n  </ul>\\n  <div>\\n      \\n      <h2 id=\\\"section-10\\\">If you reside in the UK or European Economic Area,</h2><p>and subject to exceptions and limitations provided by local law, you may exercise the following rights in addition to the rights outlined above:</p>\\n      <ul>\\n      <li>\\n<strong>Objection to Processing and Restriction of Processing:</strong> You may have the right to ask us to stop or restrict our processing of personal information for certain purposes. </li>\\n      <li>\\n<strong>Withdrawal of Consent:</strong> Where we rely on consent to process your personal information, you have the right to withdraw this consent. If you withdraw your consent, this will not affect the lawfulness of any processing based on your consent before its withdrawal.</li>\\n      </ul>\\n      \\n  </div>\\n  <p>You may exercise any of these rights where indicated on the Services or by contacting us using the contact details provided below. To learn more about how Shopify uses your personal information and any rights you may have, including rights related to data processed by Shopify, you can visit https://privacy.shopify.com/en. </p>\\n  <p>We will not discriminate against you for exercising any of these rights. We may need to verify your identity before we can process your requests, as permitted or required under applicable law. In accordance with applicable laws, you may designate an authorized agent to make requests on your behalf to exercise your rights. Before accepting such a request from an agent, we will require that the agent provide proof you have authorized them to act on your behalf, and we may need you to verify your identity directly with us. We will respond to your request in a timely manner as required under applicable law.</p>\\n  <h2 id=\\\"section-11\\\">Complaints</h2>\\n  <p>If you have complaints about how we process your personal information, please contact us using the contact details provided below. Depending on where you live, you may have the right to appeal our decision by contacting us using the contact details set out below, or lodge your complaint with your local data protection authority. For the EEA, you can find a list of the responsible data protection supervisory authorities <a href=\\\"https://edpb.europa.eu/about-edpb/about-edpb/members\\\">here</a>.</p>\\n  <h2 id=\\\"section-12\\\">International Transfers</h2>\\n  <p>Please note that we may transfer, store and process your personal information outside the country you live in. </p>\\n  <p>If we transfer your personal information out of the European Economic Area or the United Kingdom, we will rely on recognized transfer mechanisms like the European Commission's Standard Contractual Clauses, or any equivalent contracts issued by the relevant competent authority of the UK, as relevant, unless the data transfer is to a country that has been determined to provide an adequate level of protection.</p>\\n  <h2 id=\\\"section-13\\\">Changes to This Privacy Policy</h2>\\n  <p>We may update this Privacy Policy from time to time, including to reflect changes to our practices or for other operational, legal, or regulatory reasons. We will post the revised Privacy Policy on this website, update the  \\\"Last updated\\\" date and provide notice as required by applicable law.</p>\\n  <h2 id=\\\"section-14\\\">Contact</h2>\\n  <p>Should you have any questions about our privacy practices or this Privacy Policy, or if you would like to exercise any of the rights available to you, please call +1 800-561-9765 or email us at destcommerceus@gmail.com or contact us at 1309 Coffeen Ave STE 1200, Sheridan WY 82801, United States For the purpose of applicable data protection laws, we are the data controller of your personal information. </p>\\n</div>\\n    </div>\\n  \",\"slug\":\"privacy-policy\",\"description\":\"How your information is collected, used and protected.\",\"sections\":[{\"id\":\"section-1\",\"title\":\"Personal Information We Collect or Process\"},{\"id\":\"section-2\",\"title\":\"Personal Information Sources\"},{\"id\":\"section-3\",\"title\":\"How We Use Your Personal Information\"},{\"id\":\"section-4\",\"title\":\"How We Disclose Personal Information\"},{\"id\":\"section-5\",\"title\":\"Relationship with Shopify\"},{\"id\":\"section-6\",\"title\":\"Third Party Websites and Links\"},{\"id\":\"section-7\",\"title\":\"Children's Data\"},{\"id\":\"section-8\",\"title\":\"Security and Retention of Your Information\"},{\"id\":\"section-9\",\"title\":\"Your Rights and Choices\"},{\"id\":\"section-10\",\"title\":\"If you reside in the UK or European Economic Area,\"},{\"id\":\"section-11\",\"title\":\"Complaints\"},{\"id\":\"section-12\",\"title\":\"International Transfers\"},{\"id\":\"section-13\",\"title\":\"Changes to This Privacy Policy\"},{\"id\":\"section-14\",\"title\":\"Contact\"}]},{\"title\":\"Returns & refunds\",\"type\":\"REFUND_POLICY\",\"url\":\"https://checkout.shopify.com/104990441806/policies/60885827918.html?locale=en\",\"body\":\"<p>We have a 60-day return policy, which means you have 60 days after receiving your item to request a return.&nbsp;<br><br>To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase. <br><br>To start a return, you can contact us at dscommerceus@gmail.com<br><br>If your return is accepted, we’ll send you a return shipping label, as well as instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted. <br><br>You can always contact us for any return question at dscommerceus@gmail.com</p>\\n<h2 id=\\\"section-1\\\">Damages and issues</h2><p>Please inspect your order upon reception and contact us immediately if the item is defective, damaged or if you receive the wrong item, so that we can evaluate the issue and make it right.</p>\\n<p>&nbsp;</p>\\n<h2 id=\\\"section-2\\\">Refunds</h2><p>We will notify you once we’ve received and inspected your return, and let you know if the refund was approved or not. If approved, you’ll be automatically refunded on your original payment method within 10 business days. Please remember it can take some time for your bank or credit card company to process and post the refund too. <br>If more than 15 business days have passed since we’ve approved your return, please contact us at dscommerceus@gmail.com</p>\",\"slug\":\"refund-policy\",\"description\":\"Clear steps for returns, damaged items and refunds.\",\"sections\":[{\"id\":\"section-1\",\"title\":\"Damages and issues\"},{\"id\":\"section-2\",\"title\":\"Refunds\"}]},{\"title\":\"Shipping policy\",\"type\":\"SHIPPING_POLICY\",\"url\":\"https://checkout.shopify.com/104990441806/policies/60885958990.html?locale=en\",\"body\":\"<p>Once the order is placed, it takes 1-2 business days to process it. If you place your order on a Friday night or weekend, it may take a little longer. Once your order is processed, it will be shipped and delivery takes an average of 5-12 business days. We strive to make the ordering and delivery process as simple as possible for our customers. However, if you have any questions or concerns, please do not hesitate to contact our customer service team. Here is how your order will be processed and delivered.</p>\\n<h2 id=\\\"section-1\\\">Placing an order</h2><p></p>\\n<p>The ordering process at ORYNOOK is very simple. First, go to the product page and add the desired product to your shopping cart. To do this, click on the black \\\"Add to cart\\\" button.</p>\\n<p>Here it is important to check that you have selected the correct variants. If everything is in order, click on the \\\"Checkout\\\" box. On the information page, enter the correct address details. Make sure that all data is correct. Once you have filled in the data correctly, you can click on the \\\"Proceed to checkout\\\" button.</p>\\n<p>On the \\\"Shipping\\\" page, you have the possibility to check the address data you have entered. We remind you that all shipments are completely free of charge. As a token of our appreciation to our customers, we always pay the shipping and delivery costs. You can now continue by clicking on the \\\"Proceed to checkout\\\" box.</p>\\n<p>In the payment options, you can choose between different payment methods. At<span> ORYNOOK</span>, all payment options are SSL encrypted, which means you can always rely on a secure payment environment.</p>\\n<h2 id=\\\"section-2\\\">Credit Cards (AMEX, Mastercard, Maestro, Visa)</h2><p><span>&nbsp;</span>Once you have selected the correct payment method, click on the \\\"Complete Order\\\" box and you will be redirected to your chosen payment method. Follow the instructions on this page to complete your order. In the unlikely event that you have any problems with your order, you can always contact us.</p>\\n<h2 id=\\\"section-3\\\">Shipping your order</h2><p></p>\\n<p>Have you found the perfect look or accessory on our website? Then you'll want to enjoy it as soon as possible. That's why we make sure your order is processed and shipped as soon as possible. To ensure that we can charge fair prices for our products, we have chosen to group packages in large quantities and ship them all at once once we have reached our minimum quantity. We look forward to your understanding and your willingness to help us create a better and healthier world.</p>\\n<p>Please note that, like many other online stores, we are very busy and there may be delays. Please take this into account when placing your order. We will do our best to ship your order as soon as possible.</p>\\n<p>To make sure your order ships today, please contact us by email. Our service team will be happy to advise you on the most suitable solution.</p>\",\"slug\":\"shipping-policy\",\"description\":\"What to expect from processing to delivery.\",\"sections\":[{\"id\":\"section-1\",\"title\":\"Placing an order\"},{\"id\":\"section-2\",\"title\":\"Credit Cards (AMEX, Mastercard, Maestro, Visa)\"},{\"id\":\"section-3\",\"title\":\"Shipping your order\"}]},{\"title\":\"Terms of service\",\"type\":\"TERMS_OF_SERVICE\",\"url\":\"https://checkout.shopify.com/104990441806/policies/60885893454.html?locale=en\",\"body\":\"<p>This website is operated by ORYNOOK. Throughout the site, the terms “we”, “us” and “our” refer to ORYNOOK. ORYNOOK offers this website, including all information, tools and Services available from this site to you, the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here.&nbsp;<br><br>By visiting our site and/ or purchasing something from us, you engage in our “Service” and agree to be bound by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users of the site, including without limitation users who are browsers, vendors, customers, merchants, and/ or contributors of content. <br><br>Please read these Terms of Service carefully before accessing or using our website. By accessing or using any part of the site, you agree to be bound by these Terms of Service. If you do not agree to all the terms and conditions of this agreement, then you may not access the website or use any Services. If these Terms of Service are considered an offer, acceptance is expressly limited to these Terms of Service. <br><br>Any new features or tools which are added to the current store shall also be subject to the Terms of Service. You can review the most current version of the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these Terms of Service by posting updates and/or changes to our website. It is your responsibility to check this page periodically for changes. Your continued use of or access to the website following the posting of any changes constitutes acceptance of those changes. <br><br>Our store is hosted on Shopify Inc. They provide us with the online e-commerce platform that allows us to sell our products and Services to you. <br><br><strong>SECTION 1 - ONLINE STORE TERMS</strong> <br>By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site. <br>You may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws). <br>You must not transmit any worms or viruses or any code of a destructive nature. <br>A breach or violation of any of the Terms will result in an immediate termination of your Services. <br><br><strong>SECTION 2 - GENERAL CONDITIONS</strong> <br>We reserve the right to refuse Service to anyone for any reason at any time. <br>You understand that your content (not including credit card information), may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks. <br>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on the website through which the Service is provided, without express written permission by us. <br>The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms. <br><br><strong>SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</strong> <br>We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on this site is at your own risk. <br>This site may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of this site at any time, but we have no obligation to update any information on our site. You agree that it is your responsibility to monitor changes to our site. <br><br><strong>SECTION 4 - MODIFICATIONS TO THE SERVICE AND PRICES</strong> <br>Prices for our products are subject to change without notice. <br>We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. <br>We shall not be liable to you or to any third-party for any modification, price change, suspension or discontinuance of the Service. <br><br><strong>SECTION 5 - PRODUCTS OR SERVICES (if applicable)</strong> <br>Certain products or Services may be available exclusively online through the website. These products or Services may have limited quantities and are subject to return or exchange only according to our Refund Policy: <a href=\\\"/policies/refund-policy\\\">Refund policy</a> <br>We have made every effort to display as accurately as possible the colours and images of our products that appear at the store. We cannot guarantee that your computer monitor's display of any colour will be accurate.&nbsp;<br>We reserve the right, but are not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or Services that we offer. All descriptions of products or product pricing are subject to change at anytime without notice, at the sole discretion of us. We reserve the right to discontinue any product at any time. Any offer for any product or Service made on this site is void where prohibited. <br>We do not warrant that the quality of any products, Services, information, or other material purchased or obtained by you will meet your expectations, or that any errors in the Service will be corrected. <br><br><strong>SECTION 6 - ACCURACY OF BILLING AND ACCOUNT INFORMATION</strong> <br>We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the e‑mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors. <br><br>You agree to provide current, complete and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed. <br><br>For more details, please review our Refund Policy: <a href=\\\"/policies/refund-policy\\\">Refund policy</a> <br><br><strong>SECTION 7 - OPTIONAL TOOLS</strong> <br>We may provide you with access to third-party tools over which we neither monitor nor have any control nor input. <br>You acknowledge and agree that we provide access to such tools ”as is” and “as available” without any warranties, representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever arising from or relating to your use of optional third-party tools. <br>Any use by you of the optional tools offered through the site is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the terms on which tools are provided by the relevant third-party provider(s). <br>We may also, in the future, offer new Services and/or features through the website (including the release of new tools and resources). Such new features and/or Services shall also be subject to these Terms of Service. <br><br><strong>SECTION 8 - THIRD-PARTY LINKS</strong> <br>Certain content, products and Services available via our Service may include materials from third-parties. <br>Third-party links on this site may direct you to third-party websites that are not affiliated with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will not have any liability or responsibility for any third-party materials or websites, or for any other materials, products, or Services of third-parties. <br>We are not liable for any harm or damages related to the purchase or use of goods, Services, resources, content, or any other transactions made in connection with any third-party websites. Please review carefully the third-party's policies and practices and make sure you understand them before you engage in any transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the third-party. <br><br><strong>SECTION 9 - USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS</strong> <br>If, at our request, you send certain specific submissions (for example contest entries) or without a request from us, you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal mail, or otherwise (collectively, 'comments'), you agree that we may, at any time, without restriction, edit, copy, publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments. <br>We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion to be unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party’s intellectual property or these Terms of Service. <br>You agree that your comments will not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. You further agree that your comments will not contain libelous or otherwise unlawful, abusive or obscene material, or contain any computer virus or other malware that could in any way affect the operation of the Service or any related website. You may not use a false e‑mail address, pretend to be someone other than yourself, or otherwise mislead us or third-parties as to the origin of any comments. You are solely responsible for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments posted by you or any third-party. <br><br><strong>SECTION 10 - PERSONAL INFORMATION</strong> <br>Your submission of personal information through the store is governed by our Privacy Policy, which can be viewed here: <a href=\\\"/policies/privacy-policy\\\">Privacy policy</a> <br><br><strong>SECTION 11 - ERRORS, INACCURACIES AND OMISSIONS</strong> <br>Occasionally there may be information on our site or in the Service that contains typographical errors, inaccuracies or omissions that may relate to product descriptions, pricing, promotions, offers, product shipping charges, transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to change or update information or cancel orders if any information in the Service or on any related website is inaccurate at any time without prior notice (including after you have submitted your order). <br>We undertake no obligation to update, amend or clarify information in the Service or on any related website, including without limitation, pricing information, except as required by law. No specified update or refresh date applied in the Service or on any related website, should be taken to indicate that all information in the Service or on any related website has been modified or updated. <br><br><strong>SECTION 12 - PROHIBITED USES</strong> <br>In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the site or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any way that will affect the functionality or operation of the Service or of any related website, other websites, or the Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider, crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security features of the Service or any related website, other websites, or the Internet. We reserve the right to terminate your use of the Service or any related website for violating any of the prohibited uses. <br><br><strong>SECTION 13 - DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</strong> <br>We do not guarantee, represent or warrant that your use of our Service will be uninterrupted, timely, secure or error-free. <br>We do not warrant that the results that may be obtained from the use of the Service will be accurate or reliable. <br>You agree that from time to time we may remove the Service for indefinite periods of time or cancel the Service at any time, without notice to you. <br>You expressly agree that your use of, or inability to use, the Service is at your sole risk. The Service and all products and Services delivered to you through the Service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement. <br>In no case shall ORYNOOK, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, Service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the Service or any products procured using the Service, or for any other claim related in any way to your use of the Service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the Service or any content (or product) posted, transmitted, or otherwise made available via the Service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.&nbsp;<br><br><strong>SECTION 14 - INDEMNIFICATION</strong> <br>You agree to indemnify, defend and hold harmless ORYNOOK and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors, Service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms of Service or the documents they incorporate by reference, or your violation of any law or the rights of a third-party. <br><br><strong>SECTION 15 - SEVERABILITY</strong> <br>In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions. <br><br><strong>SECTION 16 - TERMINATION</strong> <br>The obligations and liabilities of the parties incurred prior to the termination date shall survive the termination of this agreement for all purposes. <br>These Terms of Service are effective unless and until terminated by either you or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our Services, or when you cease using our site. <br>If in our sole judgment you fail, or we suspect that you have failed, to comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time without notice and you will remain liable for all amounts due up to and including the date of termination; and/or accordingly may deny you access to our Services (or any part thereof). <br><br><strong>SECTION 17 - ENTIRE AGREEMENT</strong> <br>The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision. <br>These Terms of Service and any policies or operating rules posted by us on this site or in respect to the Service constitutes the entire agreement and understanding between you and us and governs your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service). <br>Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party. <br><br><strong>SECTION 18 - GOVERNING LAW</strong> <br>These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of United States. <br><br><strong>SECTION 19 - CHANGES TO TERMS OF SERVICE</strong> <br>You can review the most current version of the Terms of Service at any time at this page. <br>We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our website. It is your responsibility to check our website periodically for changes. Your continued use of or access to our website or the Service following the posting of any changes to these Terms of Service constitutes acceptance of those changes. <br><br><strong>SECTION 20 - CONTACT INFORMATION</strong> <br>Questions about the Terms of Service should be sent to us at dscommerceus@gmail.com</p>\",\"slug\":\"terms-of-service\",\"description\":\"The terms that apply when you use our store.\",\"sections\":[]}]"), Ve = (e) => "$" + (e * 34.99).toFixed(2), He = (e) => Math.floor(e / 3) * 6998 + [
	0,
	3499,
	5249
][e % 3], Ue = (e) => "$" + (He(e) / 100).toFixed(2), We = [
	"low-angle.webp",
	"central-living-room.webp",
	"overhead.webp",
	"detail-slate.webp"
], Ge = [
	["How does induction audio work?", "Place your phone on the stand with audio playing and align its speaker with the induction area. Placement matters, and results can vary by phone and case. Bluetooth is an alternative for audio playback."],
	["Does it wirelessly charge my phone?", "Phone charging uses a compatible USB cable. Induction refers to the audio feature, not wireless phone charging."],
	["Can I choose a different color?", "Yes. Choose Black or White, both $34.99 with delivery to a US address included."],
	["Is the phone included?", "No. The phone is shown to demonstrate how the stand is used. Product images are styled visualizations."],
	["Where do you deliver?", "This store is designed for customers in the United States. Delivery is included in the displayed price. Please see our Shipping policy for processing and delivery timelines."]
];
function Ke({ page: e, policySlug: t }) {
	let [n, r] = (0, G.useState)("Black"), [i, a] = (0, G.useState)(0), [o, s] = (0, G.useState)(2), [c, l] = (0, G.useState)({
		Black: 0,
		White: 0
	}), [u, d] = (0, G.useState)(!1), [f, p] = (0, G.useState)(""), [m, h] = (0, G.useState)(!0), [g, _] = (0, G.useState)(0), v = Be.find((e) => e.slug === t), [y, b] = (0, G.useState)(!1), [S, C] = (0, G.useState)(["Black", "Black"]), [w, T] = (0, G.useState)(!1), [ee, E] = (0, G.useState)(!1), [re, O] = (0, G.useState)(""), [k, ie] = (0, G.useState)(!1), j = {
		Black: 60708700455246,
		White: 60710290358606,
		fan: 60048773316942
	}, [M, ae] = (0, G.useState)(0), [I, z] = (0, G.useState)(0), oe = (e) => {
		l({
			Black: e.items.filter((e) => e.variant_id === j.Black).reduce((e, t) => e + t.quantity, 0),
			White: e.items.filter((e) => e.variant_id === j.White).reduce((e, t) => e + t.quantity, 0)
		}), _(e.items.filter((e) => e.variant_id === j.fan).reduce((e, t) => e + t.quantity, 0)), ae(e.total_price), z(e.original_total_price), T(!0);
	}, B = async (e, t) => {
		let n = await fetch(window.Shopify.routes.root + e, {
			method: t ? "POST" : "GET",
			headers: { "Content-Type": "application/json" },
			...t ? { body: JSON.stringify(t) } : {}
		}), r = await n.json();
		if (!n.ok) throw Error(r.description || "Unable to update your bag. Please try again.");
		return r;
	};
	(0, G.useEffect)(() => {
		B("cart.js").then(oe).catch((e) => O(e.message)), location.pathname === "/cart" && d(!0);
	}, []);
	let V = async (e, t) => {
		if (!k) {
			ie(!0), O("");
			try {
				await B(e, t);
				let n = await B("cart.js"), r = n.items.filter((e) => e.variant_id === j.Black || e.variant_id === j.White).reduce((e, t) => e + t.quantity, 0), i = r >= 3 ? "ORYNOOK-TRIO" : r === 2 ? "ORYNOOK-PAIR" : "";
				n = await B("cart/update.js", { discount: [...(n.discount_codes || []).filter((e) => !e.code.toUpperCase().startsWith("ORYNOOK-")).map((e) => e.code), i].filter(Boolean).join(",") }), oe(n), d(!0);
			} catch (e) {
				O(e.message), d(!0);
			} finally {
				ie(!1);
			}
		}
	}, U = (e) => V("cart/add.js", { items: [{
		id: j.fan,
		quantity: e
	}] }), W = async (e, t) => {
		if (!k) try {
			let n = (await B("cart.js")).items.filter((t) => t.variant_id === e);
			return V("cart/update.js", { updates: Object.fromEntries(n.map((e, n) => [e.key, n === 0 ? t : 0])) });
		} catch (e) {
			O(e.message);
		}
	}, K = e === "product" ? "#product" : "/products/soundglow-5-in-1-speaker-stand", pe = (0, G.useRef)(null), me = c.Black + c.White, X = me + g, Z = M, Q = (e) => "$" + (e / 100).toFixed(2), $ = n === "White" ? "white-preview.webp" : We[i];
	(0, G.useEffect)(() => {
		let e = new IntersectionObserver(([e]) => h(!e.isIntersecting), { threshold: .2 });
		pe.current && e.observe(pe.current);
		let t = new IntersectionObserver((e) => e.forEach((e) => {
			e.isIntersecting && (e.target.classList.add("revealed"), t.unobserve(e.target));
		}), { threshold: .1 });
		return document.querySelectorAll(".reveal").forEach((e) => t.observe(e)), () => {
			e.disconnect(), t.disconnect();
		};
	}, []);
	let ve = () => {
		let e = [n, ...S].slice(0, o);
		return V("cart/add.js", { items: ["Black", "White"].map((t) => ({
			id: j[t],
			quantity: e.filter((e) => e === t).length
		})).filter((e) => e.quantity) });
	}, xe = (e, t) => W(j[e], Math.max(0, c[e] + t));
	return /* @__PURE__ */ (0, q.jsxs)("main", {
		id: "top",
		className: `page-${e}`,
		children: [
			/* @__PURE__ */ (0, q.jsx)(ge, {}),
			e === "breyz" ? /* @__PURE__ */ (0, q.jsx)("div", {
				className: "bz-announcement",
				children: "FREE US SHIPPING OVER $50 · 60-DAY FREE RETURNS"
			}) : /* @__PURE__ */ (0, q.jsx)(_e, {}),
			/* @__PURE__ */ (0, q.jsxs)("nav", {
				className: "nav",
				"aria-label": "Store header",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "nav-brand-group",
					children: [/* @__PURE__ */ (0, q.jsxs)(ye, {
						open: y,
						onOpenChange: b,
						children: [/* @__PURE__ */ (0, q.jsx)(be, {
							className: "menu-toggle",
							"aria-label": "Open navigation menu",
							children: /* @__PURE__ */ (0, q.jsx)(se, { size: 24 })
						}), /* @__PURE__ */ (0, q.jsxs)(Ce, {
							side: "left",
							className: "navigation-panel",
							children: [/* @__PURE__ */ (0, q.jsxs)(we, { children: [/* @__PURE__ */ (0, q.jsx)(Te, { children: "Explore ORYNOOK" }), /* @__PURE__ */ (0, q.jsx)(Ee, { children: "Your space. Your soundtrack." })] }), /* @__PURE__ */ (0, q.jsx)("nav", {
								"aria-label": "Main navigation",
								className: "drawer-links",
								children: [
									[
										"home",
										"/",
										"Home"
									],
									[
										"catalog",
										"/collections/all",
										"Catalog"
									],
									[
										"contact",
										"/pages/contact",
										"Contact us"
									]
								].map(([t, n, r]) => /* @__PURE__ */ (0, q.jsxs)("a", {
									href: n,
									"aria-current": e === t ? "page" : void 0,
									onClick: () => b(!1),
									children: [/* @__PURE__ */ (0, q.jsx)("span", { children: r }), /* @__PURE__ */ (0, q.jsx)(x, { size: 20 })]
								}, t))
							})]
						})]
					}), /* @__PURE__ */ (0, q.jsxs)("a", {
						href: "/",
						className: "brand",
						children: [/* @__PURE__ */ (0, q.jsx)(L, {}), " ORYNOOK"]
					})]
				}), /* @__PURE__ */ (0, q.jsxs)("button", {
					className: "bag plain",
					"aria-label": `Open cart, ${X} items`,
					onClick: () => d(!0),
					children: [/* @__PURE__ */ (0, q.jsx)(A, { size: 21 }), /* @__PURE__ */ (0, q.jsx)("span", { children: X })]
				})]
			}),
			e === "breyz" && /* @__PURE__ */ (0, q.jsx)(de, { onAdd: U }),
			e === "home" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				" ",
				/* @__PURE__ */ (0, q.jsx)(fe, {}),
				/* @__PURE__ */ (0, q.jsx)(he, {})
			] }),
			e === "product" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				" ",
				/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "breadcrumbs section",
					id: "product",
					children: [
						/* @__PURE__ */ (0, q.jsx)("a", {
							href: "/",
							children: "Home"
						}),
						/* @__PURE__ */ (0, q.jsx)("span", { children: "/" }),
						/* @__PURE__ */ (0, q.jsx)("a", {
							href: "/collections/all",
							children: "Catalog"
						}),
						/* @__PURE__ */ (0, q.jsx)("span", { children: "/" }),
						/* @__PURE__ */ (0, q.jsx)("span", { children: "5-in-1 Speaker Stand" })
					]
				}),
				/* @__PURE__ */ (0, q.jsxs)("section", {
					className: "product section",
					children: [/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "gallery",
						children: [
							/* @__PURE__ */ (0, q.jsxs)("button", {
								className: "main-photo",
								onClick: () => p("photo"),
								"aria-label": "Enlarge product image",
								children: [/* @__PURE__ */ (0, q.jsx)("img", {
									src: `${window.__ORYNOOK_ASSET_ROOT__}${$}`,
									alt: `${n} ORYNOOK speaker stand`
								}), /* @__PURE__ */ (0, q.jsx)(D, {
									className: "expand",
									size: 20
								})]
							}),
							/* @__PURE__ */ (0, q.jsx)("div", {
								className: "thumbnails",
								children: (n === "Black" ? We : ["white-preview.webp"]).map((e, t) => /* @__PURE__ */ (0, q.jsx)("button", {
									onClick: () => a(t),
									"aria-label": `View ${n} product image ${t + 1}`,
									"aria-pressed": i === t,
									className: i === t ? "selected" : "",
									children: /* @__PURE__ */ (0, q.jsx)("img", {
										src: `${window.__ORYNOOK_ASSET_ROOT__}${e}`,
										alt: "",
										loading: "lazy"
									})
								}, e))
							}),
							/* @__PURE__ */ (0, q.jsx)("p", {
								className: "fine",
								children: "Styled product visualization. Phone not included."
							})
						]
					}), /* @__PURE__ */ (0, q.jsxs)("div", {
						className: "product-copy",
						children: [
							/* @__PURE__ */ (0, q.jsx)("p", {
								className: "eyebrow",
								children: "YOUR NEW EVERYDAY ESSENTIAL"
							}),
							/* @__PURE__ */ (0, q.jsxs)("h1", { children: [
								"ORYNOOK",
								/* @__PURE__ */ (0, q.jsx)("br", {}),
								"5-in-1 Speaker Stand"
							] }),
							/* @__PURE__ */ (0, q.jsx)("p", {
								className: "muted",
								children: "A home for your phone. A soundtrack for your space. Bring your daily favorites together in one compact stand."
							}),
							/* @__PURE__ */ (0, q.jsxs)("ul", {
								className: "benefits",
								children: [
									/* @__PURE__ */ (0, q.jsxs)("li", { children: [/* @__PURE__ */ (0, q.jsx)(te, {}), "Play audio with induction or Bluetooth"] }),
									/* @__PURE__ */ (0, q.jsxs)("li", { children: [/* @__PURE__ */ (0, q.jsx)(te, {}), "Keep your phone comfortably in view"] }),
									/* @__PURE__ */ (0, q.jsxs)("li", { children: [/* @__PURE__ */ (0, q.jsx)(te, {}), "Set the mood with colorful ambient light"] }),
									/* @__PURE__ */ (0, q.jsxs)("li", { children: [/* @__PURE__ */ (0, q.jsx)(te, {}), "Top up your phone with USB cable charging"] })
								]
							}),
							/* @__PURE__ */ (0, q.jsxs)("fieldset", {
								className: "offer-picker offer-redesign",
								children: [
									/* @__PURE__ */ (0, q.jsx)("legend", { children: "Find your perfect set" }),
									/* @__PURE__ */ (0, q.jsx)("p", {
										className: "offer-intro",
										children: "A little upgrade. In all your favorite places."
									}),
									/* @__PURE__ */ (0, q.jsx)(Pe, {
										"aria-label": "Choose a bundle",
										value: String(o),
										onValueChange: (e) => s(Number(e)),
										className: "offer-options",
										children: [
											{
												n: 1,
												title: "Buy 1",
												desc: "Your own little everyday upgrade.",
												price: "$34.99",
												unit: "$34.99 each",
												saving: "",
												badge: "",
												tone: "solo"
											},
											{
												n: 2,
												title: "Buy 1 Get 1 50% OFF",
												desc: "+ Free shipping",
												price: "$52.49",
												unit: "$26.25 each",
												saving: "Save $17.49",
												badge: "Our recommendation",
												tone: "pair"
											},
											{
												n: 3,
												title: "Buy 2 Get 1 FREE",
												desc: "+ Free shipping",
												price: "$69.98",
												unit: "$23.33 each",
												saving: "Save $34.99",
												badge: "Best value per stand",
												tone: "trio"
											}
										].map(({ n: e, title: t, desc: n, price: r, unit: i, saving: a, badge: s, tone: c }) => /* @__PURE__ */ (0, q.jsxs)("label", {
											className: `offer-option offer-${c} ${o === e ? "is-selected" : ""}`,
											children: [
												/* @__PURE__ */ (0, q.jsxs)("span", {
													className: "offer-topline",
													children: [
														/* @__PURE__ */ (0, q.jsxs)("span", {
															className: "offer-count",
															children: [
																String(e).padStart(2, "0"),
																" / ",
																e === 1 ? "ONE STAND" : e + " STANDS"
															]
														}),
														s && /* @__PURE__ */ (0, q.jsx)("span", {
															className: "offer-badge",
															children: s
														}),
														/* @__PURE__ */ (0, q.jsx)(Fe, { value: String(e) })
													]
												}),
												/* @__PURE__ */ (0, q.jsxs)("span", {
													className: "offer-main",
													children: [
														/* @__PURE__ */ (0, q.jsx)("span", {
															className: `offer-miniatures minis-${e}`,
															"aria-hidden": "true",
															children: Array.from({ length: e }, (e, t) => /* @__PURE__ */ (0, q.jsx)("img", {
																src: t === 1 ? window.__ORYNOOK_ASSET_ROOT__ + "white-preview.webp" : window.__ORYNOOK_ASSET_ROOT__ + "low-angle.webp",
																alt: "",
																loading: "lazy"
															}, t))
														}),
														/* @__PURE__ */ (0, q.jsxs)("span", {
															className: "offer-copy",
															children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: e === 2 ? /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: ["Buy 1 Get 1", /* @__PURE__ */ (0, q.jsx)("span", {
																style: {
																	display: "inline-block",
																	marginLeft: "0.45em",
																	whiteSpace: "nowrap"
																},
																children: "50% OFF"
															})] }) : t }), /* @__PURE__ */ (0, q.jsx)("small", { children: n })]
														}),
														/* @__PURE__ */ (0, q.jsxs)("span", {
															className: "offer-price",
															children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: r }), /* @__PURE__ */ (0, q.jsx)("small", { children: i })]
														})
													]
												}),
												/* @__PURE__ */ (0, q.jsxs)("span", {
													className: "offer-bottom",
													children: [/* @__PURE__ */ (0, q.jsx)("span", { children: e === 1 ? "Black or White" : "Mix Black & White" }), /* @__PURE__ */ (0, q.jsx)("span", { children: a || "Made for your space" })]
												})
											]
										}, e))
									}),
									/* @__PURE__ */ (0, q.jsxs)("p", {
										className: "offer-note",
										children: [
											/* @__PURE__ */ (0, q.jsx)(P, { size: 14 }),
											" Free US delivery on every set ",
											/* @__PURE__ */ (0, q.jsx)("span", { children: "·" }),
											" Savings vs. individual prices"
										]
									})
								]
							}),
							/* @__PURE__ */ (0, q.jsxs)("div", {
								className: "compact-colors",
								children: [/* @__PURE__ */ (0, q.jsx)("span", { children: "Colors" }), Array.from({ length: o }, (e, t) => {
									let i = t === 0 ? n : S[t - 1];
									return /* @__PURE__ */ (0, q.jsxs)("label", { children: [
										/* @__PURE__ */ (0, q.jsx)("span", {
											className: `swatch ${i.toLowerCase()}`,
											"aria-hidden": "true"
										}),
										/* @__PURE__ */ (0, q.jsxs)("span", {
											className: "sr-only",
											children: [
												"Stand ",
												t + 1,
												" color"
											]
										}),
										/* @__PURE__ */ (0, q.jsxs)("select", {
											value: i,
											onChange: (e) => {
												t === 0 ? (r(e.target.value), a(0)) : C((n) => n.map((n, r) => r === t - 1 ? e.target.value : n));
											},
											children: [/* @__PURE__ */ (0, q.jsxs)("option", {
												value: "Black",
												children: [t + 1, ". Black"]
											}), /* @__PURE__ */ (0, q.jsxs)("option", {
												value: "White",
												children: [t + 1, ". White"]
											})]
										})
									] }, t);
								})]
							}),
							/* @__PURE__ */ (0, q.jsx)("div", {
								ref: pe,
								className: "purchase",
								children: /* @__PURE__ */ (0, q.jsxs)("button", {
									className: "cta",
									onClick: ve,
									children: [
										"Add to bag — ",
										Ue(o),
										" ",
										/* @__PURE__ */ (0, q.jsx)(N, { size: 18 })
									]
								})
							}),
							/* @__PURE__ */ (0, q.jsxs)("p", {
								className: "shipping",
								children: [/* @__PURE__ */ (0, q.jsx)(P, { size: 18 }), " Delivered to your US address"]
							})
						]
					})]
				})
			] }),
			e === "product" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [" ", /* @__PURE__ */ (0, q.jsx)("div", {
				className: "features",
				children: [
					{
						kind: "audio",
						label: "Induction audio"
					},
					{
						kind: "bluetooth",
						label: "Bluetooth playback"
					},
					{
						kind: "stand",
						label: "Adjustable stand"
					},
					{
						kind: "charging",
						label: "USB charging"
					},
					{
						kind: "light",
						label: "Ambient light"
					}
				].map(({ kind: e, label: t }) => /* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)(J, { kind: e }), /* @__PURE__ */ (0, q.jsx)("span", { children: t })] }, e))
			})] }),
			e === "product" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				" ",
				/* @__PURE__ */ (0, q.jsxs)("section", {
					className: "how section reveal",
					id: "how",
					children: [/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("p", {
						className: "eyebrow",
						children: "LESS SETUP. MORE ENJOYING."
					}), /* @__PURE__ */ (0, q.jsxs)("h2", { children: [
						"Make yourself",
						/* @__PURE__ */ (0, q.jsx)("br", {}),
						"comfortable."
					] })] }), /* @__PURE__ */ (0, q.jsx)("div", {
						className: "steps",
						children: [
							[
								"01",
								"Find your spot",
								"On your desk, kitchen counter or bedside table."
							],
							[
								"02",
								"Make it yours",
								"Set your viewing angle and choose your audio connection."
							],
							[
								"03",
								"Press play",
								"Your playlist, your next episode, your little moment."
							]
						].map(([e, t, n]) => /* @__PURE__ */ (0, q.jsxs)("article", { children: [
							/* @__PURE__ */ (0, q.jsx)("span", { children: e }),
							/* @__PURE__ */ (0, q.jsx)("h3", { children: t }),
							/* @__PURE__ */ (0, q.jsx)("p", { children: n })
						] }, e))
					})]
				}),
				/* @__PURE__ */ (0, q.jsxs)("section", {
					className: "story section",
					children: [/* @__PURE__ */ (0, q.jsx)("div", {
						className: "story-image",
						children: /* @__PURE__ */ (0, q.jsx)("img", {
							src: window.__ORYNOOK_ASSET_ROOT__ + "desk-story.webp",
							alt: "Speaker stand on a calm home desk",
							loading: "lazy"
						})
					}), /* @__PURE__ */ (0, q.jsxs)("div", {
						className: "story-copy",
						children: [/* @__PURE__ */ (0, q.jsxs)("article", {
							className: "reveal",
							children: [
								/* @__PURE__ */ (0, q.jsx)("p", {
									className: "eyebrow",
									children: "SOUND THAT FITS YOUR DAY"
								}),
								/* @__PURE__ */ (0, q.jsxs)("h2", { children: [
									"A soundtrack.",
									/* @__PURE__ */ (0, q.jsx)("br", {}),
									"Without the juggling."
								] }),
								/* @__PURE__ */ (0, q.jsx)("p", { children: "Keep your phone upright while your favorite audio plays. Choose induction playback or connect with Bluetooth." }),
								/* @__PURE__ */ (0, q.jsx)(L, { size: 32 })
							]
						}), /* @__PURE__ */ (0, q.jsxs)("article", {
							className: "reveal",
							children: [
								/* @__PURE__ */ (0, q.jsx)("p", {
									className: "eyebrow",
									children: "A BETTER POINT OF VIEW"
								}),
								/* @__PURE__ */ (0, q.jsxs)("h2", { children: [
									"Hands free.",
									/* @__PURE__ */ (0, q.jsx)("br", {}),
									"Mind on your moment."
								] }),
								/* @__PURE__ */ (0, q.jsx)("p", { children: "Follow a recipe, settle into a show or keep your screen in view. Adjust the stand to find a comfortable angle." }),
								/* @__PURE__ */ (0, q.jsx)(ne, { size: 32 })
							]
						})]
					})]
				})
			] }),
			e === "home" && /* @__PURE__ */ (0, q.jsx)(q.Fragment, { children: /* @__PURE__ */ (0, q.jsxs)("section", {
				className: "brand-pause",
				"aria-labelledby": "brand-pause-heading",
				children: [
					/* @__PURE__ */ (0, q.jsxs)("h2", {
						id: "brand-pause-heading",
						children: [
							"Less hassle.",
							/* @__PURE__ */ (0, q.jsx)("br", {}),
							/* @__PURE__ */ (0, q.jsx)("span", { children: "More living." })
						]
					}),
					/* @__PURE__ */ (0, q.jsx)("p", { children: "Thoughtful gadgets that make room for the better parts of your day." }),
					/* @__PURE__ */ (0, q.jsx)("div", {
						className: "brand-pause-line",
						"aria-hidden": "true"
					})
				]
			}) }),
			e === "catalog" && /* @__PURE__ */ (0, q.jsxs)("section", {
				className: "catalog section",
				children: [
					/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "page-heading",
						children: [
							/* @__PURE__ */ (0, q.jsx)("p", {
								className: "eyebrow",
								children: "THE ORYNOOK COLLECTION"
							}),
							/* @__PURE__ */ (0, q.jsxs)("h1", { children: [
								"Small upgrades.",
								/* @__PURE__ */ (0, q.jsx)("br", {}),
								"Everyday favorites."
							] }),
							/* @__PURE__ */ (0, q.jsx)("p", { children: "Thoughtful essentials for the space you make your own." })
						]
					}),
					/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "catalog-label",
						children: [/* @__PURE__ */ (0, q.jsx)("span", { children: "All products" }), /* @__PURE__ */ (0, q.jsx)("span", { children: "2 products" })]
					}),
					/* @__PURE__ */ (0, q.jsxs)("div", {
						className: "catalog-products",
						children: [/* @__PURE__ */ (0, q.jsxs)("article", {
							className: "catalog-card",
							children: [
								/* @__PURE__ */ (0, q.jsxs)("a", {
									href: "/products/soundglow-5-in-1-speaker-stand",
									className: "catalog-image",
									children: [/* @__PURE__ */ (0, q.jsx)("img", {
										src: window.__ORYNOOK_ASSET_ROOT__ + "stand-catalog-white-v2.png",
										style: {
											objectFit: "contain",
											background: "#fffdfd"
										},
										alt: "Black ORYNOOK speaker stand on a white background"
									}), /* @__PURE__ */ (0, q.jsxs)("span", { children: ["Discover the details ", /* @__PURE__ */ (0, q.jsx)(x, { size: 18 })] })]
								}),
								/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("h2", { children: /* @__PURE__ */ (0, q.jsx)("a", {
									href: "/products/soundglow-5-in-1-speaker-stand",
									children: "5-in-1 Speaker Stand"
								}) }), /* @__PURE__ */ (0, q.jsx)("strong", { children: "$34.99" })] }),
								/* @__PURE__ */ (0, q.jsx)("p", { children: "Sound. Light. Your phone’s new favorite place." }),
								/* @__PURE__ */ (0, q.jsxs)("div", {
									className: "catalog-colors",
									children: [
										/* @__PURE__ */ (0, q.jsx)("span", { className: "swatch black" }),
										/* @__PURE__ */ (0, q.jsx)("span", { className: "swatch white" }),
										/* @__PURE__ */ (0, q.jsx)("span", { children: "Black / White" })
									]
								}),
								/* @__PURE__ */ (0, q.jsx)("p", {
									className: "fine",
									children: "US delivery included"
								})
							]
						}), /* @__PURE__ */ (0, q.jsxs)("article", {
							className: "catalog-card",
							children: [
								/* @__PURE__ */ (0, q.jsxs)("a", {
									href: "/products/breyz-portable-fan",
									className: "catalog-image",
									children: [/* @__PURE__ */ (0, q.jsx)("img", {
										src: Y[0],
										alt: "BREYZ Portable Fan"
									}), /* @__PURE__ */ (0, q.jsxs)("span", { children: ["Discover the details ", /* @__PURE__ */ (0, q.jsx)(x, { size: 18 })] })]
								}),
								/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("h2", { children: /* @__PURE__ */ (0, q.jsx)("a", {
									href: "/products/breyz-portable-fan",
									children: "BREYZ Portable Fan"
								}) }), /* @__PURE__ */ (0, q.jsx)("strong", { children: "$24.99" })] }),
								/* @__PURE__ */ (0, q.jsx)("p", { children: "A little breeze, wherever the day takes you." }),
								/* @__PURE__ */ (0, q.jsx)("p", {
									className: "fine",
									children: "Free US shipping on orders over $50"
								})
							]
						})]
					})
				]
			}),
			e === "contact" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsxs)("section", {
				className: "page-heading section",
				children: [
					/* @__PURE__ */ (0, q.jsx)("p", {
						className: "eyebrow",
						children: "LET’S TALK"
					}),
					/* @__PURE__ */ (0, q.jsxs)("h1", { children: [
						"A little help.",
						/* @__PURE__ */ (0, q.jsx)("br", {}),
						"A human connection."
					] }),
					/* @__PURE__ */ (0, q.jsx)("p", { children: "Questions about ORYNOOK? You’re in the right place." })
				]
			}), /* @__PURE__ */ (0, q.jsxs)("section", {
				className: "contact-layout section",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", { children: [
					/* @__PURE__ */ (0, q.jsx)("h2", { children: "Contact us" }),
					/* @__PURE__ */ (0, q.jsx)("p", { children: "Tell us what’s on your mind. For order-related questions, include your order number so our team can find the details." }),
					/* @__PURE__ */ (0, q.jsxs)("a", {
						href: "#faq",
						className: "text-link",
						children: ["Looking for a quick answer? ", /* @__PURE__ */ (0, q.jsx)(N, { size: 18 })]
					})
				] }), /* @__PURE__ */ (0, q.jsxs)("form", {
					id: "contact-form",
					className: "contact-form",
					method: "post",
					action: "/contact#contact-form",
					children: [
						/* @__PURE__ */ (0, q.jsx)("input", {
							type: "hidden",
							name: "form_type",
							value: "contact"
						}),
						/* @__PURE__ */ (0, q.jsx)("input", {
							type: "hidden",
							name: "utf8",
							value: "✓"
						}),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "form-row",
							children: [/* @__PURE__ */ (0, q.jsxs)("label", { children: ["Name", /* @__PURE__ */ (0, q.jsx)("input", {
								name: "contact[name]",
								autoComplete: "name",
								required: !0,
								maxLength: 100
							})] }), /* @__PURE__ */ (0, q.jsxs)("label", { children: ["Email", /* @__PURE__ */ (0, q.jsx)("input", {
								name: "contact[email]",
								type: "email",
								autoComplete: "email",
								required: !0,
								maxLength: 200
							})] })]
						}),
						/* @__PURE__ */ (0, q.jsxs)("label", { children: [
							"Order number ",
							/* @__PURE__ */ (0, q.jsx)("span", { children: "(optional)" }),
							/* @__PURE__ */ (0, q.jsx)("input", {
								name: "contact[Order number]",
								maxLength: 80,
								placeholder: "e.g. #1001"
							})
						] }),
						/* @__PURE__ */ (0, q.jsxs)("label", { children: ["Message", /* @__PURE__ */ (0, q.jsx)("textarea", {
							name: "contact[body]",
							rows: 6,
							required: !0,
							minLength: 10,
							maxLength: 4e3
						})] }),
						/* @__PURE__ */ (0, q.jsxs)("button", {
							className: "cta",
							type: "submit",
							children: ["Send message ", /* @__PURE__ */ (0, q.jsx)(N, { size: 18 })]
						}),
						location.search.includes("contact_posted=true") && /* @__PURE__ */ (0, q.jsx)("p", {
							role: "status",
							children: "Thank you. Your message has been sent."
						})
					]
				})]
			})] }),
			e === "home" && /* @__PURE__ */ (0, q.jsx)(q.Fragment, {}),
			e === "product" && /* @__PURE__ */ (0, q.jsx)(q.Fragment, {}),
			e === "contact" && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				/* @__PURE__ */ (0, q.jsx)(ce, {}),
				" ",
				/* @__PURE__ */ (0, q.jsxs)("section", {
					className: "contact-faq section",
					id: "faq",
					"aria-labelledby": "contact-faq-title",
					children: [/* @__PURE__ */ (0, q.jsxs)("header", { children: [/* @__PURE__ */ (0, q.jsx)("p", {
						className: "eyebrow",
						children: "THE LITTLE DETAILS"
					}), /* @__PURE__ */ (0, q.jsx)("h2", {
						id: "contact-faq-title",
						children: "Good questions. Simple answers."
					})] }), /* @__PURE__ */ (0, q.jsxs)("div", {
						className: "contact-faq-columns",
						children: [/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "contact-faq-column stand-faq-column",
							children: [
								/* @__PURE__ */ (0, q.jsx)("p", {
									className: "label",
									children: "SOUND & LIGHT"
								}),
								/* @__PURE__ */ (0, q.jsx)("h3", { children: "5-in-1 Speaker Stand" }),
								/* @__PURE__ */ (0, q.jsx)(Ie, { children: Ge.map(([e, t]) => /* @__PURE__ */ (0, q.jsxs)(Le, {
									value: e,
									children: [/* @__PURE__ */ (0, q.jsx)(Re, { children: e }), /* @__PURE__ */ (0, q.jsx)(ze, { children: /* @__PURE__ */ (0, q.jsx)("p", { children: t }) })]
								}, e)) })
							]
						}), /* @__PURE__ */ (0, q.jsx)(ue, {})]
					})]
				})
			] }),
			(e === "home" || e === "product") && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [
				" ",
				/* @__PURE__ */ (0, q.jsx)("section", {
					className: "last-call",
					children: /* @__PURE__ */ (0, q.jsxs)("div", {
						className: "reveal",
						children: [
							/* @__PURE__ */ (0, q.jsx)(L, { size: 40 }),
							/* @__PURE__ */ (0, q.jsxs)("h2", { children: [
								"A small upgrade",
								/* @__PURE__ */ (0, q.jsx)("br", {}),
								"you’ll reach for every day."
							] }),
							/* @__PURE__ */ (0, q.jsxs)("a", {
								className: "cta",
								href: K,
								children: ["Choose your ORYNOOK ", /* @__PURE__ */ (0, q.jsx)(x, { size: 20 })]
							}),
							/* @__PURE__ */ (0, q.jsx)("p", {
								className: "fine",
								children: "Black or White · $34.99 · US delivery included"
							})
						]
					})
				}),
				/* @__PURE__ */ (0, q.jsxs)("section", {
					className: "returns-assurance",
					children: [
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "returns-seal",
							children: [
								/* @__PURE__ */ (0, q.jsx)(R, { size: 25 }),
								/* @__PURE__ */ (0, q.jsx)("strong", { children: "60" }),
								/* @__PURE__ */ (0, q.jsx)("span", { children: "DAY RETURNS" })
							]
						}),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "returns-copy",
							children: [
								/* @__PURE__ */ (0, q.jsx)("p", {
									className: "eyebrow",
									children: "A LITTLE EXTRA PEACE OF MIND"
								}),
								/* @__PURE__ */ (0, q.jsx)("h2", { children: "Free returns. Room to decide." }),
								/* @__PURE__ */ (0, q.jsx)("p", { children: "Request a return within 60 days of delivery. Keep your item unused, with tags and original packaging — we’ll provide a free return label once approved." })
							]
						}),
						/* @__PURE__ */ (0, q.jsxs)("a", {
							className: "returns-link",
							href: "/policies/refund-policy",
							children: ["Returns & refunds ", /* @__PURE__ */ (0, q.jsx)(x, { size: 18 })]
						})
					]
				})
			] }),
			e === "policy" && v && /* @__PURE__ */ (0, q.jsxs)("section", {
				className: "policy-page section",
				children: [/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "policy-heading",
					children: [
						/* @__PURE__ */ (0, q.jsx)("a", {
							className: "text-link",
							href: "/",
							children: "ORYNOOK / Customer care"
						}),
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "eyebrow",
							children: "OUR STORE POLICIES"
						}),
						/* @__PURE__ */ (0, q.jsx)("h1", { children: v.title }),
						/* @__PURE__ */ (0, q.jsx)("p", { children: v.description })
					]
				}), /* @__PURE__ */ (0, q.jsxs)("div", {
					className: "policy-layout",
					children: [/* @__PURE__ */ (0, q.jsxs)("aside", { children: [
						/* @__PURE__ */ (0, q.jsx)("p", {
							className: "label",
							children: "POLICIES"
						}),
						/* @__PURE__ */ (0, q.jsx)("nav", {
							"aria-label": "Policies",
							children: Be.map((e) => /* @__PURE__ */ (0, q.jsx)("a", {
								href: "/policies/" + e.slug,
								"aria-current": e.slug === v.slug ? "page" : void 0,
								children: e.title
							}, e.slug))
						}),
						v.sections.length > 0 && /* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsx)("p", {
							className: "label contents-label",
							children: "ON THIS PAGE"
						}), /* @__PURE__ */ (0, q.jsx)("nav", {
							className: "policy-toc",
							"aria-label": "On this page",
							children: v.sections.map((e) => /* @__PURE__ */ (0, q.jsx)("a", {
								href: "#" + e.id,
								children: e.title
							}, e.id))
						})] }),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "policy-help",
							children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: "Have a question?" }), /* @__PURE__ */ (0, q.jsx)("a", {
								href: "mailto:dscommerceus@gmail.com",
								children: "dscommerceus@gmail.com"
							})]
						})
					] }), /* @__PURE__ */ (0, q.jsx)("article", {
						className: "policy-content",
						dangerouslySetInnerHTML: { __html: v.body }
					})]
				})]
			}),
			/* @__PURE__ */ (0, q.jsxs)("footer", { children: [
				/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsxs)("a", {
					href: "/",
					className: "brand",
					children: [/* @__PURE__ */ (0, q.jsx)(L, {}), "ORYNOOK"]
				}), /* @__PURE__ */ (0, q.jsx)("p", { children: "Your space. Your soundtrack." })] }),
				/* @__PURE__ */ (0, q.jsxs)("div", {
					className: "footer-links",
					children: [Be.map((e) => /* @__PURE__ */ (0, q.jsx)("a", {
						href: "/policies/" + e.slug,
						children: e.title
					}, e.slug)), /* @__PURE__ */ (0, q.jsx)("a", {
						href: "/pages/contact",
						children: "Contact us & FAQ"
					})]
				}),
				/* @__PURE__ */ (0, q.jsxs)("p", {
					className: "copyright",
					children: [
						"© ",
						(/* @__PURE__ */ new Date()).getFullYear(),
						" ORYNOOK · All rights reserved"
					]
				})
			] }),
			e === "product" && m && !u && !f && !y && /* @__PURE__ */ (0, q.jsxs)("div", {
				className: "sticky-buy",
				children: [
					/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("strong", { children: "ORYNOOK" }), /* @__PURE__ */ (0, q.jsxs)("span", { children: [
						o,
						" ",
						o === 1 ? "stand" : "stands",
						" · ",
						Ue(o)
					] })] }),
					/* @__PURE__ */ (0, q.jsx)("a", {
						href: K,
						className: "choose",
						children: "Choose color"
					}),
					/* @__PURE__ */ (0, q.jsxs)("button", {
						className: "cta",
						onClick: ve,
						children: ["Add to bag ", /* @__PURE__ */ (0, q.jsx)(A, { size: 18 })]
					})
				]
			}),
			/* @__PURE__ */ (0, q.jsx)(ye, {
				open: u,
				onOpenChange: d,
				children: /* @__PURE__ */ (0, q.jsxs)(Ce, {
					className: "cart-panel",
					children: [
						/* @__PURE__ */ (0, q.jsxs)(we, { children: [/* @__PURE__ */ (0, q.jsxs)(Te, { children: ["Your bag ", /* @__PURE__ */ (0, q.jsxs)("span", { children: [
							"(",
							X,
							")"
						] })] }), /* @__PURE__ */ (0, q.jsx)(Ee, { children: "Everyday essentials, picked by you." })] }),
						/* @__PURE__ */ (0, q.jsxs)("div", {
							className: "cart-body",
							children: [
								re && /* @__PURE__ */ (0, q.jsx)("p", {
									role: "alert",
									children: re
								}),
								k && /* @__PURE__ */ (0, q.jsx)("p", {
									role: "status",
									children: "Updating your bag…"
								}),
								X ? ["Black", "White"].filter((e) => c[e] > 0).map((e) => /* @__PURE__ */ (0, q.jsxs)("article", {
									className: "cart-item",
									children: [
										/* @__PURE__ */ (0, q.jsx)("img", {
											src: `${window.__ORYNOOK_ASSET_ROOT__}${e === "Black" ? We[0] : "white-preview.webp"}`,
											alt: `${e} stand`
										}),
										/* @__PURE__ */ (0, q.jsxs)("div", { children: [
											/* @__PURE__ */ (0, q.jsx)("h3", { children: "5-in-1 Speaker Stand" }),
											/* @__PURE__ */ (0, q.jsxs)("p", { children: [e, " · $34.99"] }),
											/* @__PURE__ */ (0, q.jsxs)("div", {
												className: "quantity",
												children: [
													/* @__PURE__ */ (0, q.jsx)("button", {
														"aria-label": `Remove one ${e} stand`,
														onClick: () => xe(e, -1),
														children: /* @__PURE__ */ (0, q.jsx)(H, { size: 14 })
													}),
													/* @__PURE__ */ (0, q.jsx)("span", { children: c[e] }),
													/* @__PURE__ */ (0, q.jsx)("button", {
														"aria-label": `Add one ${e} stand`,
														onClick: () => xe(e, 1),
														children: /* @__PURE__ */ (0, q.jsx)(F, { size: 14 })
													})
												]
											}),
											/* @__PURE__ */ (0, q.jsx)("button", {
												className: "remove",
												onClick: () => W(j[e], 0),
												children: "Remove"
											})
										] }),
										/* @__PURE__ */ (0, q.jsx)("strong", { children: Ve(c[e]) })
									]
								}, e)) : /* @__PURE__ */ (0, q.jsxs)("div", {
									className: "empty",
									children: [
										/* @__PURE__ */ (0, q.jsx)(A, { size: 48 }),
										/* @__PURE__ */ (0, q.jsx)("h3", { children: "Your everyday upgrade awaits." }),
										/* @__PURE__ */ (0, q.jsx)("button", {
											className: "cta",
											onClick: () => d(!1),
											children: "Keep exploring"
										})
									]
								}),
								g > 0 && /* @__PURE__ */ (0, q.jsxs)("article", {
									className: "cart-item",
									children: [
										/* @__PURE__ */ (0, q.jsx)("img", {
											src: Y[0],
											alt: "BREYZ Portable Fan"
										}),
										/* @__PURE__ */ (0, q.jsxs)("div", { children: [
											/* @__PURE__ */ (0, q.jsx)("h3", { children: "BREYZ Portable Fan" }),
											/* @__PURE__ */ (0, q.jsx)("p", { children: "$24.99 each" }),
											/* @__PURE__ */ (0, q.jsxs)("div", {
												className: "quantity",
												children: [
													/* @__PURE__ */ (0, q.jsx)("button", {
														"aria-label": "Remove one BREYZ fan",
														onClick: () => W(j.fan, Math.max(0, g - 1)),
														children: /* @__PURE__ */ (0, q.jsx)(H, { size: 14 })
													}),
													/* @__PURE__ */ (0, q.jsx)("span", { children: g }),
													/* @__PURE__ */ (0, q.jsx)("button", {
														"aria-label": "Add one BREYZ fan",
														onClick: () => W(j.fan, g + 1),
														children: /* @__PURE__ */ (0, q.jsx)(F, { size: 14 })
													})
												]
											}),
											/* @__PURE__ */ (0, q.jsx)("button", {
												className: "remove",
												onClick: () => W(j.fan, 0),
												children: "Remove"
											})
										] }),
										/* @__PURE__ */ (0, q.jsx)("strong", { children: Q(g * 2499) })
									]
								})
							]
						}),
						X > 0 && /* @__PURE__ */ (0, q.jsxs)("div", {
							className: "cart-total",
							children: [
								/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("span", { children: "Items" }), /* @__PURE__ */ (0, q.jsx)("strong", { children: Q(I) })] }),
								I > M && /* @__PURE__ */ (0, q.jsxs)("div", {
									className: "bundle-discount",
									children: [/* @__PURE__ */ (0, q.jsx)("span", { children: "Bundle savings" }), /* @__PURE__ */ (0, q.jsxs)("strong", { children: ["−$", ((I - M) / 100).toFixed(2)] })]
								}),
								/* @__PURE__ */ (0, q.jsxs)("div", { children: [/* @__PURE__ */ (0, q.jsx)("span", { children: "Subtotal" }), /* @__PURE__ */ (0, q.jsx)("strong", { children: Q(Z) })] }),
								me > 0 && /* @__PURE__ */ (0, q.jsx)("p", { children: "Your eligible bundle offer is applied across both colors." }),
								/* @__PURE__ */ (0, q.jsxs)("p", { children: [g > 0 ? Z > 5e3 ? "Free US shipping." : "BREYZ shipping calculated at checkout. Free US shipping over $50." : "Delivery included.", " Applicable tax calculated at checkout."] }),
								/* @__PURE__ */ (0, q.jsxs)("button", {
									className: "cta",
									onClick: () => {
										location.assign(window.Shopify.routes.root + "checkout");
									},
									disabled: k || !w,
									children: ["Checkout ", /* @__PURE__ */ (0, q.jsx)(N, { size: 18 })]
								}),
								/* @__PURE__ */ (0, q.jsx)("small", { children: "Secure checkout powered by Shopify" })
							]
						})
					]
				})
			}),
			/* @__PURE__ */ (0, q.jsx)(De, {
				open: !!f,
				onOpenChange: (e) => {
					e || p("");
				},
				children: /* @__PURE__ */ (0, q.jsxs)(Ae, {
					className: f === "photo" ? "photo-dialog" : "review-dialog",
					children: [/* @__PURE__ */ (0, q.jsxs)(je, { children: [/* @__PURE__ */ (0, q.jsx)(Me, { children: f === "photo" ? `${n} ORYNOOK` : f === "review" ? "Преглед преди публикуване" : f === "checkout" ? "You’re viewing a store preview" : f }), /* @__PURE__ */ (0, q.jsx)(Ne, { children: f === "photo" ? "Styled product visualization." : f === "review" ? "Сайтът е локална демонстрация и не е качен в Shopify." : "This website is a preview before launch." })] }), f === "photo" ? /* @__PURE__ */ (0, q.jsx)("img", {
						src: `${window.__ORYNOOK_ASSET_ROOT__}${$}`,
						alt: `${n} speaker stand enlarged`
					}) : f === "review" ? /* @__PURE__ */ (0, q.jsxs)("div", {
						className: "review-notes",
						children: [
							/* @__PURE__ */ (0, q.jsx)("p", { children: "Готови за преглед: дизайн, галерия, Black/White на $34.99, избор на количество, демонстрационна количка, анимации и следващ бутон за покупка." }),
							/* @__PURE__ */ (0, q.jsx)("p", { children: "Преди публикуване трябва да потвърдим точния модел (Round/Square), комплектовката, снимките на белия вариант, сроковете за доставка, връщанията и данните за контакт." }),
							/* @__PURE__ */ (0, q.jsx)("p", { children: "Снимките са AI визуализации. Плащанията, реалните поръчки, Shopify и Meta tracking още не са свързани към този преглед." })
						]
					}) : f === "checkout" ? /* @__PURE__ */ (0, q.jsx)("p", { children: "Your color and quantity selection works in this demo. Secure checkout will be connected to Shopify before launch. No order has been placed." }) : /* @__PURE__ */ (0, q.jsx)("p", { children: f === "Contact" ? "Customer support details will be added before launch." : f === "Shipping & returns" ? "US delivery is included in the product price. Delivery timelines and return terms are awaiting confirmation before launch." : "Store privacy and purchase terms will be finalized with the merchant’s business details before launch." })]
				})
			}),
			/* @__PURE__ */ (0, q.jsx)(le, {
				hidden: u || !!f || y,
				raised: e === "product" && m
			})
		]
	});
}
//#endregion
//#region shopify-build/components/section-transitions.tsx
function qe() {
	return (0, G.useEffect)(() => {
		let e = document.querySelector("main#top");
		if (!e) return;
		let t = Array.from(e.querySelectorAll(":scope > section, :scope > .product-carousel, :scope > .breyz-content > section, :scope > footer")), n = [], r = (e) => {
			for (; e;) {
				let t = getComputedStyle(e).backgroundColor;
				if (t !== "rgba(0, 0, 0, 0)" && t !== "transparent") return t;
				e = e.parentElement;
			}
			return "#17201f";
		};
		return t.forEach((e, i) => {
			if (!i || e.matches(".product-carousel,.brand-campaign")) return;
			let a = t[i - 1], o = document.createElement("div");
			o.className = "section-color-bridge", o.setAttribute("aria-hidden", "true"), e.classList.add("has-color-bridge"), getComputedStyle(e).position === "static" && e.classList.add("bridge-position"), o.style.setProperty("--bridge-color", r(a.matches(".product-carousel") ? a.querySelector(".core-hero") : a)), e.insertBefore(o, e.firstChild), n.push(o);
		}), () => {
			n.forEach((e) => {
				e.parentElement?.classList.remove("has-color-bridge", "bridge-position"), e.remove();
			});
		};
	}, []), null;
}
//#endregion
//#region shopify-build/entry.tsx
var Je = location.pathname, Ye = Je.includes("/products/breyz-") ? "breyz" : Je.includes("/products/") ? "product" : Je.includes("/collections/") ? "catalog" : Je.includes("/pages/contact") ? "contact" : Je.includes("/policies/") ? "policy" : "home";
(0, K.createRoot)(document.getElementById("orynook-root")).render(/* @__PURE__ */ (0, q.jsxs)(q.Fragment, { children: [/* @__PURE__ */ (0, q.jsx)(Ke, {
	page: Ye,
	policySlug: Je.split("/").pop()
}), /* @__PURE__ */ (0, q.jsx)(qe, {})] }));
//#endregion
